<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container-">
      <div class="row-">
        <div class="col-12-">
          <div class="card- card-signup- no-shadow-">
            <div class="card-body-">
              <div class="row" v-if="show == 0">
                <div class="col-md-6">
                  <div class="card" style="cursor: pointer" @click="show_user()">
                    <div class="card-body">
                      <div class="d-block d-md-flex text-center text-md-left align-content-center align-items-center">
                        <div class="img-thumbnail mr-3 rounded-circle" style="
                            max-width: 100%;
                            width: 100px;
                            position: relative;
                            height: 100px;
                            overflow: hidden;
                            flex-shrink: 0;
                          ">
                          <img :src="person.avatar" style="
                              max-width: 100px;
                              position: absolute;
                              left: 0;
                              top: 0;
                            " />
                        </div>

                        <div>
                          <div class="h5 font-weight-bold mb-0">
                            {{ $t("message.account.user-section") }}
                          </div>
                          <div class="h5 font-weight-normal text-truncate" style="">
                            {{ person.given_name }} {{ person.last_name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card" style="cursor: pointer" @click="show_company()">
                    <div class="card-body">
                      <div class="d-block d-md-flex text-center text-md-left align-content-center align-items-center">
                        <div class="img-thumbnail mr-3 rounded-circle" style="
                            max-width: 100%;
                            width: 100px;
                            position: relative;
                            height: 100px;
                            overflow: hidden;
                            flex-shrink: 0;
                          ">
                          <img :src="organization.logo" style="
                              max-width: 100px;
                              position: absolute;
                              left: 0;
                              top: 0;
                            " />
                        </div>
                        <div>
                          <div class="h5 font-weight-bold mb-0">
                            {{ $t("message.account.company-section") }}
                          </div>
                          <div class="h5 font-weight-normal text-truncate" style="">
                            {{ organization.org_name }}
                            <img v-if="is_user_privileged && !is_full" style="height: 18px; width: auto"
                              src="./../../components/homepage/assets/img/clients/atb.png" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="show == 1">
                <!--user-->
                <div class="col-12 d-none">
                  <div class="d-flex justify-content-between">
                    <button class="btn btn-sm btn-link" @click="show = 0">
                      <i class="fa fa-chevron-left"></i>
                      {{ $t("message.back") }}
                    </button>

                    <button class="btn btn-round btn-primary" @click="run_validation">
                      {{ $t("message.validate") }}
                    </button>
                    <div class="validation-frame" v-show="show_validation">
                      <button @click="show_validation = false" class="btn btn-link text-danger">
                        <i class="fa fa-times"></i>
                      </button>
                      <div class="validation-frame-inner">
                        <div v-for="(error, i) in validation_errors" :key="'val' + i" class="alert mt-3 mb-0 rounded"
                          :class="'alert' + get_alert_type(error)">
                          <div class="font-weight-bold">
                            {{ error.Name }}
                          </div>
                          <div>
                            {{ error.Text }}
                          </div>
                          <button @click="go_to_field(error)" class="btn btn-sm btn-round btn-white"
                            :class="'text' + get_alert_type(error)">
                            Исправить
                          </button>
                        </div>
                        <div v-if="validation_errors.length == 0">
                          {{ $t("message.validate_success") }}
                        </div>
                      </div>
                    </div>
                    <!--EO VALIDATION-->
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="d-flex align-items-center" style="gap: 24px">
                    <avatar-edit :url="url" :image="person.avatar" type="avatar"></avatar-edit>
                    <div class="d-none">
                      <div class="client-status">
                        <span>{{ $t("message.account.clientstatus") }}</span>
                      </div>
                      <div>
                        <span v-if="!is_user_privileged" class="bg-warning text-white p-2 rounded">{{
                          $t("message.account.tarif") }}</span>
                        <span v-if="is_user_privileged" class="bg-warning text-white p-2 rounded">{{
                          $t("message.account.atb") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="balance-block bg-secondary rounded">
                    <div class="d-flex align-items-center" style="gap: 16px">
                      <div class="icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.00025 7V13H12.0003H20.0003V7H12.0003H4.00025ZM12.0003 7C10.3434 7 9.00025 8.34315 9.00025 10C9.00025 11.6569 10.3434 13 12.0003 13C13.6571 13 15.0003 11.6569 15.0003 10C15.0003 8.34315 13.6571 7 12.0003 7ZM3.00025 5C2.44797 5 2.00025 5.44772 2.00025 6V13.977C1.99564 14.1808 2.05387 14.3805 2.16422 14.5489C2.27487 14.7171 2.43492 14.8499 2.62373 14.9267L17.6026 21.4176C17.8599 21.529 18.1521 21.5274 18.4081 21.4131C18.6641 21.2987 18.8603 21.0822 18.9489 20.8162L20.8877 15H21.0003C21.5525 15 22.0003 14.5523 22.0003 14V6C22.0003 5.44772 21.5525 5 21.0003 5H3.00025ZM17.3966 19.1486L7.82299 15H18.7795L17.3966 19.1486ZM13.0003 10C13.0003 10.5523 12.5525 11 12.0003 11C11.448 11 11.0003 10.5523 11.0003 10C11.0003 9.44772 11.448 9 12.0003 9C12.5525 9 13.0003 9.44772 13.0003 10Z"
                            fill="#FE5000" />
                        </svg>
                      </div>
                      <div>
                        <div>
                          <label for="person_code">{{
                            $t("message.account.balance")
                          }}</label>
                        </div>
                        <div>
                          <span>{{ formatted_balance }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.customer_id_ru") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.person_code }}</span>
                      <input type="text" class="form-control" id="lastname" v-model="person.person_code" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label">
                      {{ $t("message.account.org_name") }}
                    </div>
                    <div class="value">
                      <span>{{ organization.org_name }}</span>
                      <!--v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="company_code" v-model="organization.org_code" v-else> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.contracts.ap_person_person_surname") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.last_name }}</span>
                      <input type="text" class="form-control" id="lastname" v-model="person.last_name" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label">
                      {{ $t("message.reg_form.company_id_ru") }}
                    </div>
                    <div class="value">
                      <span>{{ organization.org_code }}</span>
                      <!--v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="company_code" v-model="organization.org_code" v-else> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.company_status") }}
                    </div>
                    <div class="value">
                      <span>{{
                        organization.company_status.display_text
                      }}</span>
                      <!-- <input type="text" class="form-control" id="position" v-model="organization.company_status.display_text" v-else> -->
                    </div>
                  </div>
                </div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.contracts.ap_person_person_name") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.given_name }}</span>
                      <input type="text" class="form-control" id="given_name" v-model="person.given_name" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label">
                      {{ $t("message.reg_form.company_regdate") }}
                    </div>
                    <div class="value">
                      <span>{{ organization.org_reg_date }}</span>
                      <!-- v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="org_name" v-model="organization.org_name" v-else> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label">
                      {{ $t("message.reg_form.company_reregdate") }}
                    </div>
                    <div class="value">
                      <span>{{ organization.org_reregdate }}</span>
                      <!--v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="company_code" v-model="organization.org_code" v-else> -->
                    </div>
                  </div>
                </div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.contracts.ap_person_person_middle_name") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.middle_name }}</span>
                      <input type="text" class="form-control" id="middle_name" v-model="person.middle_name" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.company_address") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.post_address }}</span>
                      <input type="text" class="form-control" id="company_address" v-model="person.post_address"
                        v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.account.residency") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{
                        organization.org_residency
                      }}</span>
                      <input type="text" class="form-control" id="company_address" v-model="organization.org_residency"
                        v-else />
                    </div>
                  </div>
                </div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.customer_gender") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{
                        person.gender == 0
                          ? $t("message.reg_form.customer_male")
                          : $t("message.reg_form.customer_female")
                      }}</span>
                      <input type="text" class="form-control" id="lastname" v-model="person.gender" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.company_oked") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{
                        organization.org_oked
                      }}</span>
                      <input type="text" class="form-control" id="position" v-model="organization.org_oked" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.reg_form.secondary_company_oked") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{
                        organization.secondary_oked
                      }}</span>
                      <input type="text" class="form-control" id="position" v-model="organization.secondary_oked"
                        v-else />
                    </div>
                  </div>
                </div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.account.phone") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{
                        person.person_phone_number
                      }}</span>
                      <input type="text" class="form-control" id="person_phone_number"
                        v-model="person.person_phone_number" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.account.position") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person">{{ person.position }}</span>
                      <input type="text" class="form-control" id="position" v-model="person.position" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>

                <div class="col-md-4 d-none">
                  <div class="account-content-block">
                    <div class="label" :class="edit_person ? 'editing-label' : ''">
                      {{ $t("message.account.email") }}
                    </div>
                    <div class="value">
                      <span v-if="!edit_person"><a :href="'mailto:' + person.person_email"
                          class="text-dark text-underline">{{ person.person_email }}</a></span>
                      <input type="text" class="form-control" id="person_email" v-model="person.person_email" v-else />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>
                <div class="col-md-4 d-none"><!--empty for grid--></div>

                <div class="col-12 align-right justify-content-end d-none">
                  <button class="btn btn-sm change-pwd-button mb-2" v-b-modal.modal-change-password>
                    {{ $t("message.account.change_password") }}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="4" y="9" width="16" height="12" rx="4" stroke="#097CB1" stroke-width="2" />
                      <path d="M12 16L12 14" stroke="#097CB1" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M16 10V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7L8 10" stroke="#097CB1"
                        stroke-width="2" />
                    </svg>
                  </button>
                  <button :class="[
                    'btn btn-primary btn-sm  mb-2 edit-profile-button',
                    edit_person ? 'bg-secondary text-white' : '',
                  ]" @click="editPerson">
                    {{ $t("message.account.edit_profile") }}
                  </button>
                </div>

                <div class="col-md-4 bg-ligh-t rounded text-center p-3">
                  <avatar-edit :url="url" :image="person.avatar" type="avatar"></avatar-edit>
                  <h4>{{ person.given_name }} {{ person.last_name }}</h4>

                  <router-link :to="{ name: 'topup-account' }" class="btn btn-info btn-sm mb-2 w-100 d-block">{{
                    $t("message.account.topup_account") }}</router-link>
                  <button :class="[
                    'btn btn-info btn-sm  mb-2 w-100 d-block',
                    edit_person ? 'bg-secondary text-white' : '',
                  ]" @click="editPerson">
                    {{ $t("message.account.edit_profile") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-change-password>
                    {{ $t("message.account.change_password") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-document-person
                    @click="fetchDocumentTypes('')">
                    {{ $t("message.account.documents_of_company") }}
                  </button>
                  <router-link :to="{ name: 'my-offers' }" class="btn btn-link w-100 d-block">{{
                    $t("message.account.offers") }}</router-link>
                  <router-link :to="{ name: 'contracts-mine' }" class="btn btn-info btn-sm mb-2 w-100 d-block">{{
                    $t("message.account.contracts") }}</router-link>
                  <router-link :to="{ name: 'account-auth-history' }" class="btn btn-info btn-sm mb-2 w-100 d-block">{{
                    $t("message.account.auth_history") }}</router-link>
                  <router-link :to="{ name: 'account-operation-history' }"
                    class="btn btn-info btn-sm mb-2 w-100 d-block">{{ $t("message.account.operation_history")
                    }}</router-link>

                  <router-link class="btn btn-info btn-sm mb-2 w-100 d-block" :to="{ name: 'topup-account-history' }">{{
                    $t("message.account.topup_history") }}</router-link>

                  <button v-if="userRole16" class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-team>
                    {{ $t("message.account.team") }}
                  </button>
                  <button v-if="userRole16" class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-team-anal>
                    {{ $t("message.account.team") }} Аналитика
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-socials-persons>
                    {{ $t("message.account.socials") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-signatures>
                    {{ $t("message.account.signatures") }}
                  </button>
                </div>
                <div class="col-md-8">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="person_code">{{
                        $t("message.account.balance")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span>{{ formatted_balance }}</span>
                      <router-link :to="{ name: 'topup-account' }" class="btn btn-sm btn-primary ml-2">{{
                        $t("message.account.topup_account") }}</router-link>
                    </div>
                  </div>

                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_code">{{
                        $t("message.reg_form.company_id_ru")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span>{{ organization.org_code }}</span>
                      <!--v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="company_code" v-model="organization.org_code" v-else> -->
                    </div>
                  </div>

                  <div class="row align-items-center my-2">
                    <div class="col-md-4">
                      <span>{{ $t("message.account.clientstatus") }}</span>
                    </div>
                    <div class="col-md-8 text-rig-ht">
                      <span v-if="!is_user_privileged" class="bg-warning text-white p-2 rounded">{{
                        $t("message.account.tarif") }}</span>
                      <span v-if="is_user_privileged" class="bg-warning text-white p-2 rounded">{{
                        $t("message.account.atb") }}</span>
                    </div>
                  </div>

                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_name">{{
                        $t("message.account.org_name")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span>{{ organization.org_name }}
                        <img v-if="is_user_privileged && !is_full" style="height: 18px; width: auto"
                          src="./../../components/homepage/assets/img/clients/atb.png" alt="" /></span>
                      <!-- v-if="!edit_person"-->
                      <!-- <input type="text" class="form-control" id="org_name" v-model="organization.org_name" v-else> -->
                    </div>
                    <div class="col-md-12 mb-4" v-if="!is_user_privileged">
                      {{ $t("message.account.atb_info") }}
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_address">{{
                        $t("message.reg_form.company_address")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.post_address }}</span>
                      <input type="text" class="form-control" id="company_address" v-model="person.post_address"
                        v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="position">{{
                        $t("message.account.position")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.position }}</span>
                      <input type="text" class="form-control" id="position" v-model="person.position" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="lastname">{{
                        $t("message.contracts.ap_person_person_surname")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.last_name }}</span>
                      <input type="text" class="form-control" id="lastname" v-model="person.last_name" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="given_name">{{
                        $t("message.contracts.ap_person_person_name")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.given_name }}</span>
                      <input type="text" class="form-control" id="given_name" v-model="person.given_name" v-else />
                    </div>
                  </div>
                  <div class="d-none row align-items-center">
                    <div class="col-md-4">
                      <label for="person_code">{{
                        $t("message.account.iin")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.middle_name }}</span>
                      <input type="text" class="form-control" id="person_code" v-model="person.middle_name" v-else />
                    </div>
                  </div>
                  <div class="d-none row align-items-center">
                    <div class="col-md-4">
                      <label for="position">{{
                        $t("message.account.position")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.position }}</span>
                      <input type="text" class="form-control" id="position" v-model="person.position" v-else />
                    </div>
                  </div>
                  <div class="d-none row align-items-center">
                    <div class="col-md-4">
                      <label for="date_of_birth">{{
                        $t("message.account.dob")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        person.date_of_birth
                      }}</span>
                      <datepicker @focus="person.date_of_birth = ' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="
                        person.date_of_birth == ' '
                          ? (person.date_of_birth = '')
                          : (person.date_of_birth = person.date_of_birth)
                        " inputClass="form-control" v-else v-model="person.date_of_birth"
                        :placeholder="$t('message.account.dob')" :inputAttr="{ id: 'date_of_birth' }" />
                      <!-- <b-form-datepicker :locale="locale" v-model="person.date_of_birth" :placeholder="$t('message.account.dob')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="date_of_birth" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="d-none row align-items-center">
                    <div class="col-md-4">
                      <label for="address">{{
                        $t("message.account.address")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.post_address }}</span>
                      <input type="text" class="form-control" id="address" v-model="person.post_address" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="email">{{
                        $t("message.account.email")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.person_email }}</span>
                      <input type="text" class="form-control" id="email" v-model="person.person_email" v-else />
                    </div>
                  </div>
                  <div class="d-none togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.gender") }}</span><br /><br />
                      <input type="checkbox" v-model="person.gender" :disabled="!edit_person" />
                      <span class="toggle"></span>
                      <span class="female">{{
                        $t("message.reg_form.customer_female")
                      }}</span>
                      <span class="male">{{
                        $t("message.reg_form.customer_male")
                      }}</span>
                    </label>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="phone">{{
                        $t("message.account.phone")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        person.person_phone_number
                      }}</span>
                      <input type="text" class="form-control" id="phone" v-model="person.person_phone_number" v-else />
                    </div>
                  </div>
                  <div class="d-none row align-items-center">
                    <div class="col-md-4">
                      <label for="residency">{{
                        $t("message.account.residency")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        display_text_value(person.country)
                      }}</span>
                      <!-- <v-select id="residency" :options="countries" label="display_text" :class="['form-control', typeof person.country !== 'undefined' && person.country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="person.country" v-else></v-select> -->

                      <v-select-popup v-else type="country" v-model="person.country"
                        :placeholder="$t('message.account.residency')" />
                    </div>
                  </div>
                  <div class="row my-2" v-if="edit_person">
                    <div class="col-12">
                      <button class="btn btn-success" @click="savePerson()">
                        {{ $t("message.save") }}
                      </button>
                    </div>
                  </div>
                  <div class="row d-none">
                    <div class="col-12">
                      <a v-show="!empty(socials_person.skype)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="'skype:' + socials_person.skype"><i
                          class="text-info fab fa-skype fa-2x"></i></a>
                      <a v-show="!empty(socials_person.linkedin)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials_person.linkedin"><i
                          class="text-info fab fa-linkedin fa-2x"></i></a>
                      <a v-show="!empty(socials_person.fb)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials_person.fb"><i
                          class="text-info fab fa-facebook fa-2x"></i></a>
                      <a v-show="!empty(socials_person.instagram)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials_person.instagram"><i
                          class="text-info fab fa-instagram fa-2x"></i></a>
                      <a v-show="!empty(socials_person.vk)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials_person.vk"><i
                          class="text-info fab fa-vk fa-2x"></i></a>
                      <a v-show="!empty(socials_person.wechat)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="'weixin://dl/chat?' + socials_person.wechat"><i
                          class="text-info fab fa-weixin fa-2x"></i></a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <!-- <div id="person_map" :class="['mt-3', 'rounded', loading_map?'loading-map':'']" style="height: 300px;"></div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="show == 2">
                <!--company-->
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <button class="btn btn-sm btn-link" @click="show = 0">
                      <i class="fa fa-chevron-left"></i>
                      {{ $t("message.back") }}
                    </button>
                    <button class="btn btn-round btn-primary" @click="run_validation">
                      {{ $t("message.validate") }}
                    </button>
                    <div class="validation-frame" v-show="show_validation">
                      <button @click="show_validation = false" class="btn btn-link text-danger">
                        <i class="fa fa-times"></i>
                      </button>
                      <div class="validation-frame-inner">
                        <div v-for="(error, i) in validation_errors" :key="'val' + i" class="alert mt-3 mb-0 rounded"
                          :class="'alert' + get_alert_type(error)">
                          <div class="font-weight-bold">
                            {{ error.Name }}
                          </div>
                          <div>
                            {{ error.Text }}
                          </div>
                          <button @click="go_to_field(error)" class="btn btn-sm btn-round btn-white"
                            :class="'text' + get_alert_type(error)">
                            Исправить
                          </button>
                        </div>
                        <div v-if="validation_errors.length == 0">
                          {{ $t("message.validate_success") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 bg-ligh-t rounded text-center p-3">
                  <avatar-edit :url="url_company" :image="organization.logo" type="logo"></avatar-edit>
                  <h4>{{ organization.org_name }}</h4>
                  <button :class="[
                    'btn btn-info btn-sm  mb-2 w-100 d-block',
                    edit_company ? 'bg-secondary text-white' : '',
                  ]" @click="editCompany">
                    {{ $t("message.account.edit_profile") }}
                  </button>

                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-account
                    @click="fetchForAcoount()">
                    {{ $t("message.account.accounts_of_company") }}
                  </button>

                  <router-link v-if="is_twh" :to="{ name: 'twh-index' }" @click="show_menu = false"
                    class="btn btn-info btn-sm mb-2 w-100 d-block">
                    {{ $t("message.menu.twh") }}
                  </router-link>

                  <button v-if="is_insurer" class="btn btn-info btn-sm mb-2 w-100 d-block"
                    v-b-modal.modal-insurance_requests-insurer @click="fetchForAcoountInsuranceInsurer()">
                    {{ $t("message.account.insurance_requests") }}
                  </button>
                  <button v-if="!is_insurer" class="btn btn-info btn-sm mb-2 w-100 d-block"
                    v-b-modal.modal-insurance_requests @click="fetchForAcoountInsurance()">
                    {{ $t("message.account.insurance_requests") }}
                  </button>

                  <router-link :to="{ name: 'admin-sad-builder' }" v-if="is_admin"
                    class="btn btn-info btn-sm mb-2 w-100 d-block">{{ $t("message.account.admin_sad_builder")
                    }}</router-link>

                  <!-- <button v-if="is_broker" class="btn btn-link w-100 d-block" v-b-modal.modal-broker_requests @click="fetchForAcountBroker()">{{$t('message.account.broker_requests')}}</button> -->

                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-addresses
                    @click="fetchCountries('')">
                    {{ $t("message.account.addresses_of_company") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-founders
                    @click="fetchCountries('')">
                    {{ $t("message.account.founders_of_company") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-socials>
                    {{ $t("message.account.socials") }}
                  </button>
                  <button class="btn btn-info btn-sm mb-2 w-100 d-block" v-b-modal.modal-document
                    @click="fetchDocumentTypes('')">
                    {{ $t("message.account.documents_of_company") }}
                  </button>

                  <button :class="[
                    'btn btn-info btn-sm  mb-2 w-100 d-block',
                    view_offers ? 'bg-secondary text-white' : '',
                  ]" @click="viewOffers">
                    {{ $t("message.account.offer_requests") }}
                  </button>

                  <button v-if="organization.org_is_bank" class="btn btn-info btn-sm mb-2 w-100 d-block"
                    v-b-modal.modal-bank-pre-contracts>
                    {{ $t("message.account.pre_contracts") }}
                  </button>

                  <!--<div class="dropdown">
										<button class="btn btn-link dropdown-toggle"  type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											{{$t('message.account.offer_requests')}}&nbsp;&nbsp;
										</button>
										<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
											<a class="dropdown-item w-100"  @click="" >{{$t('message.account.offers_full')}}</a>
											<a class="dropdown-item w-100"  @click="" >{{$t('message.account.transport_requests')}}</a>

											<a class="dropdown-item w-100"  @click="" >{{$t('message.account.broker_requests')}}</a>
											<a class="dropdown-item w-100"  @click="" >{{$t('message.account.broker_requests')}}</a>
										</div>
									</div> -->

                  <div style="position: absolute; bottom: 0">
                    <a :href="offer_link_url" target="_blank" class="link-primary">{{ $t("message.account.pa_oferta")
                      }}</a>
                  </div>
                </div>

                <div class="col-md-8">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_name">{{
                        $t("message.account.org_name")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{ organization.org_name }}
                        <img v-if="!is_full" style="height: 18px; width: auto"
                          src="./../../components/homepage/assets/img/clients/atb.png" alt="" /></span>
                      <input type="text" class="form-control" id="org_name" v-model="organization.org_name" v-else />
                    </div>
                    <div class="col-md-12 mb-4">
                      {{ $t("message.account.atb_info") }}
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_code">{{
                        $t("message.account.bin")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_code
                      }}</span>
                      <input type="text" class="form-control" id="company_code" v-model="organization.org_code"
                        v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_custom_code">{{
                        $t("message.account.org_custom_code")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_custom_code
                      }}</span>
                      <input type="text" class="form-control" id="org_custom_code"
                        v-model="organization.org_custom_code" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_oked">{{
                        $t("message.account.org_oked")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        display_text_value(organization.org_oked)
                      }}</span>
                      <!-- <v-select id="org_oked" :options="okeds" label="display_text" :class="['form-control', typeof organization.org_oked !== 'undefined' && organization.org_oked.value!==''?'vs--selected':'']" @search=fetchOkeds v-model="organization.org_oked" v-else></v-select> -->

                      <v-select-popup v-else type="oked" v-model="organization.org_oked"
                        :placeholder="$t('message.account.org_oked')" />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_type">{{
                        $t("message.account.org_type")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        display_text_value(organization.org_type)
                      }}</span>
                      <!-- <v-select id="org_type" :options="org_types" label="display_text" :class="['form-control', typeof organization.org_type !== 'undefined' && organization.org_type.value!==''?'vs--selected':'']" @search=fetchOrgTypes v-model="organization.org_type" v-else></v-select> -->

                      <v-select-popup v-else type="org_type" v-model="organization.org_type"
                        :placeholder="$t('message.account.org_type')" />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_contacts">{{
                        $t("message.account.company_contacts")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_contacts
                      }}</span>
                      <input type="text" class="form-control" id="company_contacts"
                        v-model="organization.company_contacts" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_reg_date">{{
                        $t("message.account.org_reg_date")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_reg_date
                      }}</span>
                      <datepicker v-else @focus="organization.org_reg_date = ' '" value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY" @blur="
                          organization.org_reg_date == ' '
                            ? (organization.org_reg_date = '')
                            : (organization.org_reg_date =
                              organization.org_reg_date)
                          " inputClass="form-control" v-model="organization.org_reg_date"
                        :placeholder="$t('message.account.org_reg_date')" :inputAttr="{ id: 'org_reg_date' }" />
                      <!-- <b-form-datepicker :locale="locale" v-model="organization.org_reg_date" :placeholder="$t('message.account.org_reg_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="org_reg_date" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_reregdate">{{
                        $t("message.account.org_reregdate")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_reregdate
                      }}</span>
                      <datepicker v-else @focus="organization.org_reregdate = ' '" value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY" @blur="
                          organization.org_reregdate == ' '
                            ? (organization.org_reregdate = '')
                            : (organization.org_reregdate =
                              organization.org_reregdate)
                          " inputClass="form-control" v-model="organization.org_reregdate"
                        :placeholder="$t('message.account.org_reregdate')" :inputAttr="{ id: 'org_reregdate' }" />
                      <!-- <b-form-datepicker :locale="locale" v-model="organization.org_reregdate" :placeholder="$t('message.account.org_reg_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="org_reregdate" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_status">{{
                        $t("message.account.company_status")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        display_text_value(organization.company_status)
                      }}</span>
                      <!-- <v-select id="company_status" :options="statuses" label="display_text" :class="['form-control', typeof organization.company_status !== 'undefined' && organization.company_status.value!==''?'vs--selected':'']" @search=fetchStatuses v-model="organization.company_status" v-else></v-select> -->

                      <v-select-popup v-else type="status" v-model="organization.company_status"
                        :placeholder="$t('message.account.company_status')" />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_founder">{{
                        $t("message.account.company_ceo")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_founder
                      }}</span>
                      <input type="text" class="form-control" id="company_founder"
                        v-model="organization.company_founder" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_ceo_date">{{
                        $t("message.account.company_ceo_date")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_ceo_date
                      }}</span>
                      <datepicker v-else @focus="organization.company_ceo_date = ' '" value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY" @blur="
                          organization.company_ceo_date == ' '
                            ? (organization.company_ceo_date = '')
                            : (organization.company_ceo_date =
                              organization.company_ceo_date)
                          " inputClass="form-control" v-model="organization.company_ceo_date"
                        :placeholder="$t('message.account.company_ceo_date')" :inputAttr="{ id: 'company_ceo_date' }" />
                      <!-- <b-form-datepicker v-else :locale="locale" v-model="organization.company_ceo_date" :placeholder="$t('message.account.company_ceo_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="company_ceo_date" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_filials">{{
                        $t("message.account.company_filials")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_filials
                      }}</span>
                      <input type="text" class="form-control" id="company_filials"
                        v-model="organization.company_filials" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_website">{{
                        $t("message.account.company_website")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_website
                      }}</span>
                      <input type="text" class="form-control" id="company_website"
                        v-model="organization.company_website" v-else />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="country">{{
                        $t("message.account.country")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        display_text_value(organization.country)
                      }}</span>
                      <!-- <v-select id="residency" :options="countries" label="display_text" :class="['form-control', typeof organization.country !== 'undefined' && organization.country!==''?'vs--selected':'']" @search=fetchCountries v-model="organization.country" v-else></v-select> -->

                      <v-select-popup v-else type="country" v-model="organization.country"
                        :placeholder="$t('message.account.country')" />
                    </div>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_broker") }}</span><br /><br />
                      <input type="checkbox" v-model="organization.org_is_broker" :disabled="!edit_company" />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_carrier") }}</span><br /><br />
                      <input type="checkbox" v-model="organization.org_is_carrier" :disabled="!edit_company" />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_bank") }}</span><br /><br />
                      <input type="checkbox" v-model="organization.org_is_bank" :disabled="!edit_company" />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_insurer") }}</span><br /><br />
                      <input type="checkbox" v-model="organization.org_is_insurer" :disabled="!edit_company" />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-md-12 mb-3 mb-md-0">
                      <label for="country">{{
                        $t("message.account.kpved")
                      }}</label>
                    </div>
                    <div class="col-md-12 mb-3" v-if="!edit_company">
                      <span class="badge badge-info text-truncate overflow-hidden d-inline-block"
                        style="max-width: 100%" v-for="(label, index) in organization_kpveds_tags" :key="index"
                        :title="label">{{ label }}</span>
                    </div>
                    <div class="col-md-12" v-if="edit_company" style="margin-top: -20px">
                      <claster-selector v-model="organization.organization_kpveds" id="kpved"
                        :label="$t('message.contracts.good_selector')"
                        :label2="$t('message.contracts.good_selector_c1')"
                        :label3="$t('message.contracts.good_selector_c2')"
                        :label4="$t('message.contracts.good_selector_c3')"
                        :label5="$t('message.contracts.good_selector_c4')"
                        :label6="$t('message.contracts.good_selector_c5')" type="kpved"
                        :required="true"></claster-selector>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a v-show="!empty(socials.skype)" class="text-info mr-2" target="_blank" rel="noopener noreferrer"
                        :href="'skype:' + socials.skype"><i class="text-info fab fa-skype fa-2x"></i></a>
                      <a v-show="!empty(socials.linkedin)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials.linkedin"><i
                          class="text-info fab fa-linkedin fa-2x"></i></a>
                      <a v-show="!empty(socials.fb)" class="text-info mr-2" target="_blank" rel="noopener noreferrer"
                        :href="socials.fb"><i class="text-info fab fa-facebook fa-2x"></i></a>
                      <a v-show="!empty(socials.instagram)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="socials.instagram"><i
                          class="text-info fab fa-instagram fa-2x"></i></a>
                      <a v-show="!empty(socials.vk)" class="text-info mr-2" target="_blank" rel="noopener noreferrer"
                        :href="socials.vk"><i class="text-info fab fa-vk fa-2x"></i></a>
                      <a v-show="!empty(socials.wechat)" class="text-info mr-2" target="_blank"
                        rel="noopener noreferrer" :href="'weixin://dl/chat?' + socials.wechat"><i
                          class="text-info fab fa-weixin fa-2x"></i></a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <!-- <div id="company_map" :class="['mt-3', 'rounded', loading_map_company?'loading-map':'']" style="height: 300px;"></div> -->
                    </div>
                  </div>
                  <div class="row my-2" v-if="edit_company">
                    <div class="col-12">
                      <button class="btn btn-success" @click="saveCompany()">
                        {{ $t("message.save") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="show == 3">
                <!--offers-->
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <button class="btn btn-sm btn-link" @click="
                      show = 2;
                    view_offers = false;
                    ">
                      <i class="fa fa-chevron-left"></i>
                      {{ $t("message.back") }}
                    </button>
                  </div>
                </div>
                <account-all-offers></account-all-offers>
              </div>

              <!--<h1>{{organization.org_name}}</h1>
							<dl>
								<dt>{{$t('message.account.bin')}}:</dt>
								<dd>{{organization.org_code}}</dd>

								<dt>{{$t('message.account.company-country')}}:</dt>
								<dd>{{residency.display_text}}</dd>
							</dl>
							<hr class="my-4">
							<h2>{{person.given_name}} {{person.last_name}}</h2>
							<dl>
								<dt>{{$t('message.account.iin')}}:</dt>
								<dd>{{person.person_code}}</dd>

								<dt>{{$t('message.account.dob')}}:</dt>
								<dd>{{momentum(person.date_of_birth)}}</dd>

								<dt>{{$t('message.account.gender')}}:</dt>
								<dd>{{gender(person.gender)}}</dd>
							</dl>

							<router-link :to="{name: 'account-edit'}" class="btn btn-success">{{$t('message.edit')}}</router-link>
							-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-team" centered :hide-footer="true" size="xl" :title="$t('message.account.team')">
      <team />
    </b-modal>
    <b-modal id="modal-team-anal" centered :hide-footer="true" size="xl"
      :title="$t('message.account.team') + ' Аналитика'">
      <teamAnalytics />
    </b-modal>
    <b-modal id="modal-signatures" centered :hide-footer="true" size="sm" :title="$t('message.account.signatures')">
      <div class="alert" v-if="cert_exists" :class="cert_valid ? 'alert-success' : 'alert-danger'">
        {{ $t("message.account.cert_installed") }}<br />
        {{ $t("message.account.cert_start_date") }}: {{ this.cert_start_date
        }}<br />
        {{ $t("message.account.end_start_date") }}: {{ this.end_start_date
        }}<br />
        {{ $t("message.account.cert_bin") }}: {{ this.cert_bin }}<br />
      </div>
      <button class="btn btn-success" @click="add_new_signature">
        {{ $t("message.account.add_new_cert") }}
      </button>
    </b-modal>
    <b-modal id="modal-change-password" centered size="md" :hide-footer="true"
      :title="$t('message.account.change_password')">
      <div class="form-group">
        <label for="old_password">{{
          $t("message.account.old_password")
        }}</label>
        <input type="password" id="old_password" class="form-control" v-model="old_password"
          :placeholder="$t('message.account.current_password')" />
      </div>
      <div class="text-danger" v-if="wrong_old_password">
        {{ $t("message.account.old_password_wrong") }}
      </div>
      <div class="text-danger" v-if="insecure_new_password">
        {{ $t("message.account.insecure_new_password") }}
      </div>
      <div class="text-danger" v-if="short_new_password">
        {{ $t("message.account.short_new_password") }}
      </div>

      <div class="form-group">
        <label for="new_password">{{
          $t("message.account.new_password")
        }}</label>
        <input type="password" id="new_password" class="form-control" v-model="new_password"
          :placeholder="$t('message.account.new_password')" />
      </div>
      <div class="form-group">
        <label for="confirm_password">{{
          $t("message.account.confirm_password")
        }}</label>
        <input type="password" id="confirm_password" class="form-control" v-model="confirm_password"
          :placeholder="$t('message.account.repeat_new_password')" />
      </div>
      <div class="form-button-group d-flex justify-content-end gap-20 mb-4">
        <button class="btn btn-outline-secondary" @click="$bvModal.hide('modal-change-password')">
          {{ $t("message.cancel") }}
        </button>
        <button class="btn btn-primary" @click="savePassword">
          {{ $t("message.save") }}
        </button>
      </div>
    </b-modal>
    <b-modal id="modal-socials" centered :hide-footer="true" :title="$t('message.account.socials')">
      <div class="form-group">
        <label for="skype">Skype</label>
        <input type="text" id="skype" class="form-control" v-model="socials.skype" />
      </div>
      <div class="form-group">
        <label for="linkedin">LinkedIn</label>
        <input type="text" id="linkedin" class="form-control" v-model="socials.linkedin" />
      </div>
      <div class="form-group">
        <label for="facebook">Facebook</label>
        <input type="text" id="facebook" class="form-control" v-model="socials.fb" />
      </div>
      <div class="form-group">
        <label for="instagram">Instagram</label>
        <input type="text" id="instagram" class="form-control" v-model="socials.instagram" />
      </div>
      <div class="form-group">
        <label for="vk">VK</label>
        <input type="text" id="vk" class="form-control" v-model="socials.vk" />
      </div>
      <div class="form-group">
        <label for="wechat">WeChat</label>
        <input type="text" id="wechat" class="form-control" v-model="socials.wechat" />
      </div>

      <button class="btn btn-success" @click="saveSocials">
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal id="modal-socials-persons" centered :hide-footer="true" :title="$t('message.account.socials')">
      <div class="form-group">
        <label for="skype">Skype</label>
        <input type="text" id="skype" class="form-control" v-model="socials_person.skype" />
      </div>
      <div class="form-group">
        <label for="linkedin">LinkedIn</label>
        <input type="text" id="linkedin" class="form-control" v-model="socials_person.linkedin" />
      </div>
      <div class="form-group">
        <label for="facebook">Facebook</label>
        <input type="text" id="facebook" class="form-control" v-model="socials_person.fb" />
      </div>
      <div class="form-group">
        <label for="instagram">Instagram</label>
        <input type="text" id="instagram" class="form-control" v-model="socials_person.instagram" />
      </div>
      <div class="form-group">
        <label for="vk">VK</label>
        <input type="text" id="vk" class="form-control" v-model="socials_person.vk" />
      </div>
      <div class="form-group">
        <label for="wechat">WeChat</label>
        <input type="text" id="wechat" class="form-control" v-model="socials_person.wechat" />
      </div>

      <button class="btn btn-success" @click="saveSocialsPerson">
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal id="modal-account" centered :hide-footer="true" :title="$t('message.account.accounts_of_company')">
      <div class="alert" :class="'alert' + get_alert_type(banks_error_text)" v-if="show_banks_error">
        {{ banks_error_text.Text }}
      </div>
      <table class="table table-responsive">
        <thead>
          <th>{{ $t("message.account.bank") }}</th>
          <th>{{ $t("message.account.account") }}</th>
          <th>{{ $t("message.account.currency") }}</th>
          <th>{{ $t("message.account.is_open") }}</th>
          <th></th>
        </thead>
        <tr v-for="(bank, index) in subj_bank_accounts" :key="index">
          <td>{{ display_text_value(bank.subj_bank) }}</td>
          <td style="max-width: 120px; overflow: hidden; text-overflow: ellipsis" :title="bank.subj_bank_acc_number">
            {{ bank.subj_bank_acc_number }}
          </td>
          <td>{{ display_text_value(bank.subj_bank_acc_curr) }}</td>
          <td>
            {{
              bank.subj_bank_acc_status == true
                ? $t("message.yes")
                : $t("message.no")
            }}
          </td>
          <td>
            <button class="btn btn-link text-info btn-sm" @click="editBank(index)">
              <i class="fa fa-edit"></i></button><button class="btn btn-link text-danger btn-sm"
              @click="removeBank(index)">
              <i class="fa fa-times"></i>
            </button>
          </td>
        </tr>
      </table>
      <div class="form-group">
        <!-- <label for="bank">{{$t('message.account.bank')}}</label> -->
        <!-- <v-select id="bank" :options="banks" label="display_text" :class="['form-control', typeof new_bank.subj_bank !== 'undefined' && new_bank.subj_bank!==''?'vs--selected':'']" @search="fetchBank" v-model="new_bank.subj_bank"></v-select> -->

        <v-select-popup type="bank" v-model="new_bank.subj_bank" :placeholder="$t('message.account.bank')" />
      </div>
      <div class="form-group">
        <label for="account">{{ $t("message.account.account") }}</label>
        <input type="text" id="account" class="form-control" v-model="new_bank.subj_bank_acc_number" />
      </div>
      <div class="form-group">
        <!-- <label for="currency">{{$t('message.account.currency')}}</label> -->
        <!-- <v-select id="currency" :options="currencies" label="display_text" :class="['form-control', typeof new_bank.subj_bank_acc_curr !== 'undefined' && new_bank.subj_bank_acc_curr!==''?'vs--selected':'']" @search=fetchCurrency v-model="new_bank.subj_bank_acc_curr"></v-select> -->

        <v-select-popup type="currency" v-model="new_bank.subj_bank_acc_curr"
          :placeholder="$t('message.account.currency')" />
      </div>
      <div class="form-group">
        <label for="is_open">{{ $t("message.account.is_open") }}</label>
        <input type="checkbox" id="is_open" class="ml-2 mt-1" v-model="new_bank.subj_bank_acc_status" />
      </div>
      <button class="btn btn-info btn-sm" @click="addBank()" v-if="!edit_bank">
        {{ $t("message.account.add_bank") }}
      </button>
      <button class="btn btn-info btn-sm" @click="saveBank()" v-else>
        {{ $t("message.account.save_bank") }}</button><br /><br />
      <button class="btn btn-success" @click="saveBanks">
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal id="modal-insurance_requests" centered :hide-footer="true"
      :title="$t('message.account.insurance_requests')">
      <!-- <button v-if="!add_insurance_request" @click="addInsuranceRequest()" class="btn btn-round btn-rounded btn-info btn-sm">{{$t('message.account.add_insurance_requests')}}</button> -->
      <div v-if="add_insurance_request">
        <button class="btn btn-sm btn-default mb-3" @click="cancelAddInsurance()">
          &larr; {{ $t("message.back") }}
        </button>
        <!-- <div class="alert" :class="'alert-danger'" v-if="edit_insurance_requst && current_insurance_request.status=='returned'">
					{{current_insurance_request.insurer_message}}
				</div> -->
        <!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  contract_id_focus?'focused':'']">
					<v-select id="contract_id" :options="contracts" label="display_text" :class="['form-control', typeof current_insurance_request.contract_id !== 'undefined' && current_insurance_request.contract_id.value!==''?'vs--selected':'']" @search=loadMyContracts() v-model="current_insurance_request.contract_id" :placeholder="$t('message.account.contract')" @focus="contract_id_focus = true" @blur="contract_id_focus=false"></v-select>	
					<label for="contract_id" class="form-label-group-label shorter">{{$t('message.account.contract')}}</label>
				</span> -->
        <!-- <div class="row">
					


					<div class="col-md-6">
						<div class="form-group">
							<label for="insurance_statute">{{$t('message.account.statute')}}</label>
							<input type="file" id="insurance_statute" class="form-control1" @change="fileHandleInsurance($event, 'statute')">
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="insurance_registration_certificate">{{$t('message.account.registration_certificate')}}</label>
							<input type="file" id="insurance_registration_certificate" class="form-control1" @change="fileHandleInsurance($event, 'registration_certificate')">
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="insurance_signature_right_certificate">{{$t('message.account.signature_right_certificate')}}</label>
							<input type="file" id="insurance_signature_right_certificate" class="form-control1" @change="fileHandleInsurance($event, 'signature_right_certificate')">
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="insurance_ceo_passport">{{$t('message.account.ceo_passport')}}</label>
							<input type="file" id="insurance_ceo_passport" class="form-control1" @change="fileHandleInsurance($event, 'ceo_passport')">
						</div>
					</div>
				</div> -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="border rounded p-3">
              <h5>
                {{ $t("message.account.insurers_list") }}
              </h5>
              <div class="alert-light alert rounded" v-if="current_insurance_request.insurers.length == 0">
                {{ $t("message.account.insurers_list_empty") }}
              </div>
              <div class="table table-responsive" v-else>
                <b-table :fields="insurer_list_fields" :items="current_insurance_request.insurers">
                  <template v-slot:cell(status)="data">
                    {{
                      $t(
                        "message.account.insurance_request_status_" +
                        data.value,
                      )
                    }}
                  </template>
                  <template v-slot:cell(prices)="data">
                    <div v-if="
                      data.item.offer_sent == 1 ||
                      data.item.status == 'approved'
                    ">
                      {{ $t("message.account.insurance_price") }}:
                      <b>{{
                        data.item.price
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$& ")
                      }}</b>
                    </div>
                    <div v-if="
                      data.item.offer_sent == 1 ||
                      data.item.status == 'approved'
                    ">
                      {{ $t("message.account.insurance_franchise") }}:
                      <b>{{
                        data.item.franchise
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$& ")
                      }}</b>
                    </div>
                  </template>
                  <template v-slot:cell(insurer_message)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell(actions)="data">
                    <button v-if="
                      data.item.status == 'approved' &&
                      data.item.select_status == 0
                    " class="btn btn-sm btn-success" @click="select_insurer_from_the_list(data.item)">
                      {{ $t("message.account.insurers_list_insurer_select") }}
                    </button>
                    <button v-if="
                      data.item.status == 'returned' && !edit_insurer_request
                    " class="btn btn-sm btn-default" @click="edit_insurer_from_the_list(data.item)">
                      {{ $t("message.edit") }}
                    </button>
                    <button v-if="
                      data.item.status == 'returned' && edit_insurer_request
                    " class="btn btn-sm btn-default" @click="edit_insurer_request = false">
                      {{ $t("message.cancel") }}
                    </button>
                    <button v-if="
                      data.item.status == 'approved' &&
                      data.item.select_status == 1 &&
                      data.item.offer_sent == 1 &&
                      !data.item.is_signed
                    " class="btn btn-sm btn-primary" @click="sign_insurer_from_the_list(data.item)">
                      {{ $t("message.account.insurers_list_insurer_sign") }}
                    </button>
                    <div v-if="data.item.is_signed == 1">
                      {{ $t("message.account.insurance_request_signed")
                      }}<br />{{ data.item.when_signed }},
                      {{ data.item.who_signed }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!edit_insurer_request">
          <div class="col-6 text-muted">
            {{ $t("message.account.org_name") }}
          </div>
          <div class="col-6">
            {{ current_insurance_request.org_name }}
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.ceo_name") }}
          </div>
          <div class="col-6">
            {{ current_insurance_request.ceo_name }}
          </div>

          <div class="col-6 text-muted">
            {{ $t("message.account.statute") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.statute" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.statute") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.registration_certificate") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.registration_certificate" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.registration_certificate") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.signature_right_certificate") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.signature_right_certificate" target="_blank"
              rel="noopener noreferrer">{{
                $t("message.account.signature_right_certificate") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.ceo_passport") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.ceo_passport" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.ceo_passport") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
        </div>
        <div class="bg-success-light p-3" v-if="edit_insurer_request">
          <div class="row">
            <div class="col-12">
              <h3>{{ $t("message.account.edit_insurance_request") }}</h3>
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.insurers_list_insurer_orgname") }}
            </div>
            <div class="col-6 mb-4">
              {{ current_edit_insurer_request.insurer_orgname }}
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.org_name") }}
            </div>
            <div class="col-6 mb-3">
              <input class="form-control" type="text" v-model="current_edit_insurer_request.org_name" />
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.ceo_name") }}
            </div>
            <div class="col-6 mb-3">
              <input class="form-control" type="text" v-model="current_edit_insurer_request.ceo_name" />
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.amount") }}
            </div>
            <div class="col-6 mb-3">
              <input class="form-control" type="number" v-model="current_edit_insurer_request.amount" />
            </div>

            <div class="col-6 text-muted">
              {{ $t("message.account.statute") }}
            </div>
            <div class="col-6 mb-3">
              <a :href="current_insurance_request.statute" target="_blank" rel="noopener noreferrer">{{
                $t("message.account.statute") }}
                <i class="fas fa-external-link-alt"></i></a>
              <div>{{ $t("message.account.or_upload_new") }}</div>
              <input class="form-control" type="file" @change="handle_file_upload_edit_request($event, 'statute')" />
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.registration_certificate") }}
            </div>
            <div class="col-6 mb-3">
              <a :href="current_insurance_request.registration_certificate" target="_blank" rel="noopener noreferrer">{{
                $t("message.account.registration_certificate") }}
                <i class="fas fa-external-link-alt"></i></a>
              <div>{{ $t("message.account.or_upload_new") }}</div>
              <input class="form-control" type="file" @change="
                handle_file_upload_edit_request(
                  $event,
                  'registration_certificate',
                )
                " />
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.signature_right_certificate") }}
            </div>
            <div class="col-6 mb-3">
              <a :href="current_insurance_request.signature_right_certificate" target="_blank"
                rel="noopener noreferrer">{{
                  $t("message.account.signature_right_certificate") }}
                <i class="fas fa-external-link-alt"></i></a>
              <div>{{ $t("message.account.or_upload_new") }}</div>
              <input class="form-control" type="file" @change="
                handle_file_upload_edit_request(
                  $event,
                  'signature_right_certificate',
                )
                " />
            </div>
            <div class="col-6 text-muted">
              {{ $t("message.account.ceo_passport") }}
            </div>
            <div class="col-6 mb-3">
              <a :href="current_insurance_request.ceo_passport" target="_blank" rel="noopener noreferrer">{{
                $t("message.account.ceo_passport") }}
                <i class="fas fa-external-link-alt"></i></a>
              <div>{{ $t("message.account.or_upload_new") }}</div>
              <input class="form-control" type="file" @change="
                handle_file_upload_edit_request($event, 'ceo_passport')
                " />
            </div>
          </div>
        </div>
        <!-- load document -->
        <div :class="edit_insurer_request ? 'bg-success-light p-3' : ''">
          <form-insurance :readonly="!edit_insurer_request" :is_edit="edit_insurer_request"
            v-if="current_insurance_request.insurance_type == 6"
            :document_id="current_insurance_request.document_id"></form-insurance>
          <form-liability-insurance :readonly="!edit_insurer_request" :is_edit="edit_insurer_request" v-else
            :document_id="current_insurance_request.document_id"></form-liability-insurance>
        </div>
        <!-- end load document -->

        <!-- <button class="btn btn-success" @click="saveInsuranceRequest">
					{{$t('message.save')}}
				</button> -->
        <!-- <a class="btn btn-success mt-5" v-if="typeof current_insurance_request.certificate==='string' && current_insurance_request.certificate!==''" :href="current_insurance_request.certificate" target=_blank>{{$t('message.contracts.download_insurance_certificate')}}</a> -->
        <button class="btn btn-default ml-5 float-right mt-5" @click="cancelAddInsurance()">
          {{ $t("message.cancel") }}
        </button>
      </div>
      <div v-if="!add_insurance_request" class="table table-responsive">
        <b-table :fields="insurance_requests_fields" :items="my_insurance_requests">
          <template v-slot:cell(action)="data">
            <button class="btn btn-link p-0" @click="editInsuranceRequest(data.item, data.index)"
              :title="$t('message.contracts.show_ktzh_request')">
              <i class="fa fa-eye"></i>
            </button>
          </template>
          <template v-slot:cell(status)="data">
            {{ $t("message.account.insurance_request_status_" + data.value) }}
          </template>
          <template v-slot:cell(date_time)="data">
            {{ data.value }}
          </template>
          <template v-slot:cell(amount)="data">
            {{ data.value.toLocaleString() }}
          </template>
          <template v-slot:cell(insurance_type)="data">
            {{ $t("message.account.insurance_type_" + data.value) }}
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal id="modal-insurance_requests-insurer" centered :hide-footer="true"
      :title="$t('message.account.insurance_requests')">
      <div v-if="show_insurance_request">
        <div class="row">
          <div class="col-6 text-muted">
            {{ $t("message.account.org_name") }}
          </div>
          <div class="col-6">
            {{ current_insurance_request.org_name }}
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.ceo_name") }}
          </div>
          <div class="col-6">
            {{ current_insurance_request.ceo_name }}
          </div>

          <div class="col-6 text-muted">
            {{ $t("message.account.statute") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.statute" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.statute") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.registration_certificate") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.registration_certificate" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.registration_certificate") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.signature_right_certificate") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.signature_right_certificate" target="_blank"
              rel="noopener noreferrer">{{
                $t("message.account.signature_right_certificate") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.ceo_passport") }}
          </div>
          <div class="col-6">
            <a :href="current_insurance_request.ceo_passport" target="_blank" rel="noopener noreferrer">{{
              $t("message.account.ceo_passport") }}
              <i class="fas fa-external-link-alt"></i></a>
          </div>
        </div>

        <!-- load document -->
        <form-insurance :readonly="true" v-if="current_insurance_request.insurance_type == 6"
          :document_id="current_insurance_request.document_id"></form-insurance>
        <form-liability-insurance :readonly="true" v-else
          :document_id="current_insurance_request.document_id"></form-liability-insurance>
        <!-- end load document -->

        <div v-if="accept_insurance_request" class="mt-3 bg-success-light p-3 rounded">
          <h3>{{ $t("message.account.add_insurance_contract_details") }}</h3>
          <!-- <div class="form-group">
						<label for="insurance_request_certificate">{{$t('message.account.insurance_request_certificate')}}</label>
						<input type="file" id="insurance_request_certificate" class="form-control1" @change="fileHandleInsurance($event, 'certificate')">
					</div> -->
          <div class="col-6 text-muted">
            {{ $t("message.account.insurance_price") }}
          </div>
          <div class="col-6 mb-3">
            <!-- <input class="form-control" type="number" v-model="insurer_submit_details_price"> -->
            <cleave v-model="insurer_submit_details_price" :options="cleaveWeight" class="form-control"
              autocomplete="off" style="cursor: auto"></cleave>
          </div>
          <div class="col-6 text-muted">
            {{ $t("message.account.insurance_franchise") }}
          </div>
          <div class="col-6 mb-3">
            <!-- <input class="form-control" type="number" v-model="insurer_submit_details_franchise"> -->
            <cleave v-model="insurer_submit_details_franchise" :options="cleaveWeight" class="form-control"
              autocomplete="off" style="cursor: auto"></cleave>
          </div>
          <div class="col-12">
            <!-- <button class="btn btn-success" @click="insurer_submit_details_to_request()">
							{{$t('message.account.insurance_submit')}}
						</button> -->
            <button class="btn btn-success" @click="acceptInsuranceRequest">
              {{ $t("message.approve") }}
            </button>
            <button class="btn btn-default" @click="accept_insurance_request = false">
              {{ $t("message.cancel") }}
            </button>
          </div>
        </div>
        <div v-if="return_insurance_request" class="mt-3">
          <textarea v-model="current_insurance_request.insurer_message" class="form-control" :placeholder="$t('message.account.insurance_request_insurer_message')
            " cols="30" rows="10"></textarea>
          <button class="btn btn-danger" @click="returnInsuranceRequest">
            {{ $t("message.return") }}
          </button>
          <button class="btn btn-default" @click="return_insurance_request = false">
            {{ $t("message.cancel") }}
          </button>
        </div>
        <div v-if="
          !accept_insurance_request &&
          !return_insurance_request &&
          current_insurance_request.select_status == 0 &&
          current_insurance_request.status !== 'approved' &&
          current_insurance_request.status !== 'returned'
        " class="mt-3">
          <button class="btn btn-success" @click="accept_insurance_request = true">
            {{ $t("message.approve") }}
          </button>
          <button class="btn btn-danger ml-2" @click="return_insurance_request = true">
            {{ $t("message.return") }}
          </button>
          <button class="btn btn-default ml-5" @click="show_insurance_request = false">
            {{ $t("message.back") }}
          </button>
        </div>
        <!-- <div v-if="current_insurance_request.select_status==1 && !insurer_submit_details && !current_insurance_request.offer_sent">
					<button class="btn btn-success" @click="insurer_submit_details=true">
						{{$t('message.account.insurer_submit_details')}}
					</button>
				</div> -->
        <!-- <div v-if="insurer_submit_details" class="bg-success-light p-3 rounded">
					<div class="row">
						<div class="col-6 text-muted">
							{{$t('message.account.insurance_price')}}
						</div>
						<div class="col-6 mb-3">
							<input class="form-control" type="number" v-model="insurer_submit_details_price">
						</div>
						<div class="col-6 text-muted">
							{{$t('message.account.insurance_franchise')}}
						</div>
						<div class="col-6 mb-3">
							<input class="form-control" type="number" v-model="insurer_submit_details_franchise">
						</div>
						<div class="col-12">
							<button class="btn btn-success" @click="insurer_submit_details_to_request()">
								{{$t('message.account.insurance_submit')}}
							</button>
						</div>
					</div>
				</div> -->
      </div>
      <div v-if="!show_insurance_request">
        <b-table :fields="insurance_requests_fields_all" :items="all_insurance_requests">
          <template v-slot:cell(action)="data">
            <button class="btn btn-link p-0" @click="showInsuranceRequest(data.item)"
              :title="$t('message.contracts.show_ktzh_request')">
              <i class="fa fa-eye"></i>
            </button>
          </template>
          <template v-slot:cell(status)="data">
            {{ $t("message.account.insurance_request_status_" + data.value) }}
          </template>
          <template v-slot:cell(date_time)="data">
            {{ data.value }}
          </template>
          <template v-slot:cell(amount)="data">
            {{ data.value.toLocaleString() }}
          </template>
          <template v-slot:cell(insurance_type)="data">
            {{ $t("message.account.insurance_type_" + data.value) }}
          </template>
          <template v-slot:cell(select_status)="data">
            {{
              $t(
                "message.account.insurers_list_insurer_select_status_" +
                data.value,
              )
            }}
          </template>
        </b-table>
      </div>
    </b-modal>

    <b-modal id="modal-founders" centered :hide-footer="true" :title="$t('message.account.founders_of_company')">
      <table class="table table-responsive">
        <thead>
          <th>{{ $t("message.account.org_founders_person_name") }}</th>
          <th>{{ $t("message.account.org_founders_company") }}</th>
          <th>{{ $t("message.account.org_founders_share") }}</th>
          <th>{{ $t("message.account.org_founders_country") }}</th>
          <th></th>
        </thead>
        <tr v-for="(founder, index) in organizations_founders" :key="index">
          <td>{{ founder.org_founders_person_name }}</td>
          <td>{{ founder.org_founders_company }}</td>
          <td>{{ founder.org_founders_share }}</td>
          <td>{{ display_text_value(founder.org_founders_country) }}</td>
          <td>
            <button class="btn btn-link text-info btn-sm" @click="editFounder(index)">
              <i class="fa fa-edit"></i></button><button class="btn btn-link text-danger btn-sm"
              @click="removeFounder(index)">
              <i class="fa fa-times"></i>
            </button>
          </td>
        </tr>
      </table>
      <div class="form-group">
        <label for="org_founders_person_name">{{
          $t("message.account.org_founders_person_name")
        }}</label>
        <input type="text" id="org_founders_person_name" class="form-control"
          v-model="new_founder.org_founders_person_name" />
      </div>
      <div class="form-group">
        <label for="org_founders_company">{{
          $t("message.account.org_founders_company")
        }}</label>
        <input type="text" id="org_founders_company" class="form-control" v-model="new_founder.org_founders_company" />
      </div>
      <div class="form-group">
        <label for="org_founders_share">{{
          $t("message.account.org_founders_share")
        }}</label>
        <input type="number" id="org_founders_share" class="form-control" v-model="new_founder.org_founders_share" />
      </div>
      <div class="form-group">
        <!-- <label for="org_founders_country">{{$t('message.account.org_founders_country')}}</label> -->
        <!-- <v-select id="org_founders_country" :options="countries" label="display_text" :class="['form-control', typeof new_founder.org_founders_country !== 'undefined' && new_founder.org_founders_country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="new_founder.org_founders_country"></v-select> -->

        <v-select-popup type="country" v-model="new_founder.org_founders_country"
          :placeholder="$t('message.account.org_founders_country')" />
      </div>
      <button class="btn btn-info btn-sm" @click="addFounder()" v-if="!edit_founder">
        {{ $t("message.account.add_founder") }}
      </button>
      <button class="btn btn-info btn-sm" @click="saveFounder()" v-else>
        {{ $t("message.account.save_founder") }}</button><br /><br />
      <button class="btn btn-success" @click="saveFounders">
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal id="modal-addresses" centered :hide-footer="true" :title="$t('message.account.addresses_of_company')">
      <b-tabs pills content-class="mt-3" small v-model="current_address_tab">
        <b-tab :title="$t('message.account.jur_address')" lazy>
          <div class="form-group">
            <!-- <label for="address_country1">{{$t('message.account.post_addr_country')}}</label> -->
            <!-- <v-select id="address_country1" :options="countries" label="display_text" :class="['form-control', typeof address_1.post_addr_country !== 'undefined' && address_1.post_addr_country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="address_1.post_addr_country"></v-select> -->

            <v-select-popup type="country" v-model="address_1.post_addr_country"
              :placeholder="$t('message.account.post_addr_country')" />
          </div>
          <div class="form-group">
            <label for="address_index_1">{{
              $t("message.account.index")
            }}</label>
            <input type="text" id="address_index_1" class="form-control" v-model="address_1.post_addr_index" />
          </div>
          <div class="form-group">
            <label for="address_region_1">{{
              $t("message.account.region")
            }}</label>
            <input type="text" id="address_region_1" class="form-control" v-model="address_1.post_addr_region" />
          </div>
          <div class="form-group">
            <label for="address_district_1">{{
              $t("message.account.district")
            }}</label>
            <input type="text" id="address_district_1" class="form-control" v-model="address_1.post_addr_district" />
          </div>
          <div class="form-group">
            <label for="address_town_1">{{ $t("message.account.town") }}</label>
            <input type="text" id="address_town_1" class="form-control" v-model="address_1.post_addr_town" />
          </div>
          <div class="form-group">
            <label for="address_city_1">{{ $t("message.account.city") }}</label>
            <input type="text" id="address_city_1" class="form-control" v-model="address_1.post_addr_city" />
          </div>
          <div class="form-group">
            <label for="address_street_1">{{
              $t("message.account.street")
            }}</label>
            <input type="text" id="address_street_1" class="form-control" v-model="address_1.post_addr_streethouse" />
          </div>
          <div class="form-group">
            <label for="address_house_1">{{
              $t("message.account.house")
            }}</label>
            <input type="text" id="address_house_1" class="form-control" v-model="address_1.post_addr_house" />
          </div>
          <div class="form-group">
            <label for="address_room_1">{{ $t("message.account.room") }}</label>
            <input type="text" id="address_room_1" class="form-control" v-model="address_1.post_addr_room" />
          </div>
          <div class="form-group">
            <label for="address_number_1">{{
              $t("message.account.number")
            }}</label>
            <input type="text" id="address_number_1" class="form-control" v-model="address_1.post_addr_comm_number" />
          </div>
        </b-tab>
        <b-tab :title="$t('message.account.post_address')" lazy>
          <button class="btn btn-outline-success btn-block btn-sm" @click="cloneAddress('post')">
            {{ $t("message.account.address_clone") }}
          </button>
          <div class="form-group">
            <!-- <label for="address_country2">{{$t('message.account.post_addr_country')}}</label> -->
            <!-- <v-select id="address_country2" :options="countries" label="display_text" :class="['form-control', typeof address_2.post_addr_country !== 'undefined' && address_2.post_addr_country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="address_2.post_addr_country"></v-select> -->
            <v-select-popup type="country" v-model="address_2.country"
              :placeholder="$t('message.account.post_addr_country')" />
          </div>
          <div class="form-group">
            <label for="address_index_2">{{
              $t("message.account.index")
            }}</label>
            <input type="text" id="address_index_2" class="form-control" v-model="address_2.post_addr_index" />
          </div>
          <div class="form-group">
            <label for="address_region_2">{{
              $t("message.account.region")
            }}</label>
            <input type="text" id="address_region_2" class="form-control" v-model="address_2.post_addr_region" />
          </div>
          <div class="form-group">
            <label for="address_district_2">{{
              $t("message.account.district")
            }}</label>
            <input type="text" id="address_district_2" class="form-control" v-model="address_2.post_addr_district" />
          </div>
          <div class="form-group">
            <label for="address_town_2">{{ $t("message.account.town") }}</label>
            <input type="text" id="address_town_2" class="form-control" v-model="address_2.post_addr_town" />
          </div>
          <div class="form-group">
            <label for="address_city_2">{{ $t("message.account.city") }}</label>
            <input type="text" id="address_city_2" class="form-control" v-model="address_2.post_addr_city" />
          </div>
          <div class="form-group">
            <label for="address_street_2">{{
              $t("message.account.street")
            }}</label>
            <input type="text" id="address_street_2" class="form-control" v-model="address_2.post_addr_streethouse" />
          </div>
          <div class="form-group">
            <label for="address_house_2">{{
              $t("message.account.house")
            }}</label>
            <input type="text" id="address_house_2" class="form-control" v-model="address_2.post_addr_house" />
          </div>
          <div class="form-group">
            <label for="address_room_2">{{ $t("message.account.room") }}</label>
            <input type="text" id="address_room_2" class="form-control" v-model="address_2.post_addr_room" />
          </div>
          <div class="form-group">
            <label for="address_number_2">{{
              $t("message.account.number")
            }}</label>
            <input type="text" id="address_number_2" class="form-control" v-model="address_2.post_addr_comm_number" />
          </div>
        </b-tab>
        <b-tab :title="$t('message.account.fact_address')" lazy>
          <button class="btn btn-outline-success btn-block btn-sm" @click="cloneAddress('fact')">
            {{ $t("message.account.address_clone") }}
          </button>
          <div class="form-group">
            <!-- <label for="address_country3">{{$t('message.account.post_addr_country')}}</label> -->
            <!-- <v-select id="address_country3" :options="countries" label="display_text" :class="['form-control', typeof address_3.post_addr_country !== 'undefined' && address_3.post_addr_country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="address_3.post_addr_country"></v-select> -->

            <v-select-popup type="country" v-model="address_3.country"
              :placeholder="$t('message.account.post_addr_country')" />
          </div>
          <div class="form-group">
            <label for="address_index_3">{{
              $t("message.account.index")
            }}</label>
            <input type="text" id="address_index_3" class="form-control" v-model="address_3.post_addr_index" />
          </div>
          <div class="form-group">
            <label for="address_region_3">{{
              $t("message.account.region")
            }}</label>
            <input type="text" id="address_region_3" class="form-control" v-model="address_3.post_addr_region" />
          </div>
          <div class="form-group">
            <label for="address_district_3">{{
              $t("message.account.district")
            }}</label>
            <input type="text" id="address_district_3" class="form-control" v-model="address_3.post_addr_district" />
          </div>
          <div class="form-group">
            <label for="address_town_3">{{ $t("message.account.town") }}</label>
            <input type="text" id="address_town_3" class="form-control" v-model="address_3.post_addr_town" />
          </div>
          <div class="form-group">
            <label for="address_city_3">{{ $t("message.account.city") }}</label>
            <input type="text" id="address_city_3" class="form-control" v-model="address_3.post_addr_city" />
          </div>
          <div class="form-group">
            <label for="address_street_3">{{
              $t("message.account.street")
            }}</label>
            <input type="text" id="address_street_3" class="form-control" v-model="address_3.post_addr_streethouse" />
          </div>
          <div class="form-group">
            <label for="address_house_3">{{
              $t("message.account.house")
            }}</label>
            <input type="text" id="address_house_3" class="form-control" v-model="address_3.post_addr_house" />
          </div>
          <div class="form-group">
            <label for="address_room_3">{{ $t("message.account.room") }}</label>
            <input type="text" id="address_room_3" class="form-control" v-model="address_3.post_addr_room" />
          </div>
          <div class="form-group">
            <label for="address_number_3">{{
              $t("message.account.number")
            }}</label>
            <input type="text" id="address_number_3" class="form-control" v-model="address_3.post_addr_comm_number" />
          </div>
        </b-tab>
      </b-tabs>

      <button class="btn btn-success" @click="saveAddresses">
        {{ $t("message.save") }}
      </button>
    </b-modal>

    <b-modal id="modal-document" centered :hide-footer="true" :title="$t('message.account.documents_of_company')">
      <div class="form-group">
        <!-- <label for="document_types">{{$t('message.contracts.document_types')}}</label> -->
        <!-- <v-select id="document_types" :options="pa_document_types" label="display_text" :class="['form-control', typeof new_document.document_type_current !== 'undefined' && new_document.document_type_current !==''?'vs--selected':'']" @search=fetchDocumentTypes v-model="new_document.document_type_current"></v-select> -->

        <v-select-popup type="pa_document_types" v-model="new_document.document_type_current"
          :placeholder="$t('message.contracts.document_types')" />
      </div>
      <div class="form-group">
        <label for="document_number">{{
          $t("message.account.document_number")
        }}</label>
        <input type="text" id="document_number" class="form-control" v-model="new_document.document_number" />
      </div>
      <div class="form-group">
        <label for="document_serial">{{
          $t("message.account.document_serial")
        }}</label>
        <input type="text" id="document_serial" class="form-control" v-model="new_document.document_serial" />
      </div>
      <div class="form-group">
        <datepicker @focus="new_document.document_date = ' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="
          new_document.document_date == ' '
            ? (new_document.document_date = '')
            : (new_document.document_date = new_document.document_date)
          " inputClass="form-control" v-model="new_document.document_date"
          :placeholder="$t('message.contracts.document_date')" :inputAttr="{ id: 'document_date' }" />
        <!-- <b-form-datepicker :locale="locale" v-model="new_document.document_date" :placeholder="$t('message.account.document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_date"></b-form-datepicker> -->
        <label v-if="new_document.document_date != ''" for="document_date"
          class="form-label-group-label shorter topped">{{
            $t("message.account.document_date") }}</label>
      </div>
      <div class="form-group">
        <datepicker @focus="new_document.document_exp_date = ' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="
          new_document.document_exp_date == ' '
            ? (new_document.document_exp_date = '')
            : (new_document.document_exp_date =
              new_document.document_exp_date)
          " inputClass="form-control" v-model="new_document.document_exp_date"
          :placeholder="$t('message.account.document_exp_date')" :inputAttr="{ id: 'document_exp_date' }" />
        <!-- <b-form-datepicker :locale="locale" v-model="new_document.document_exp_date" :placeholder="$t('message.account.document_exp_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_exp_date"></b-form-datepicker> -->
        <label v-if="new_document.document_exp_date != ''" for="document_exp_date"
          class="form-label-group-label shorter topped">{{ $t("message.account.document_exp_date") }}</label>
      </div>
      <div class="form-group">
        <label for="document_issued_by">{{
          $t("message.account.document_issued_by")
        }}</label>
        <input type="text" id="document_issued_by" class="form-control" v-model="new_document.document_issued_by" />
      </div>
      <div class="togglebutton mt-md-3 form-label-group">
        <label class="control-label-sm">
          <span>{{ $t("message.account.document_active") }}</span><br /><br />
          <input type="checkbox" v-model="new_document.is_active" />
          <span class="toggle"></span>
          <span class="female">{{ $t("message.yes") }}</span>
          <span class="male">{{ $t("message.no") }}</span>
        </label>
      </div>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="new_document.file.id != ''">
        {{ $t("message.contracts.document_file") }}:
        <a target="_blank" :href="'/document/getfile/' + new_document.file.id">{{ new_document.file.name }}</a>
        <button class="btn btn-link text-danger btn-sm" @click="removeFile()">
          <i class="fa fa-trash"></i>
        </button>
      </span>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="new_document.file.id == ''">
        <input type="file" class="form-control" :placeholder="$t('message.contracts.document_file')" autocomplete="off"
          style="cursor: auto" id="document_file" @change="fileSelected($event)" />
        <label for="document_file" class="form-label-group-label shorter pb-0">{{ $t("message.contracts.document_file")
          }}</label>
      </span>
      <div class="table table-responsive">
        <table class="table">
          <thead>
            <th>{{ $t("message.contracts.document_types") }}</th>
            <th>{{ $t("message.account.document_number") }}</th>
            <th>{{ $t("message.account.document_date") }}</th>
            <th>{{ $t("message.account.document_exp_date") }}</th>
            <th></th>
          </thead>
          <tr v-for="(doc, index) in company_documents" :key="index">
            <td :title="doc.document_type">
              {{ display_text_value(doc.document_type) }}
            </td>
            <td :title="doc.document_number">{{ doc.document_number }}</td>
            <td :title="doc.document_date">{{ doc.document_date }}</td>
            <td :title="doc.document_exp_date">{{ doc.document_exp_date }}</td>
            <td>
              <button class="btn btn-link text-info btn-sm" @click="editDocument(index)">
                <i class="fa fa-edit"></i></button><button class="btn btn-link text-danger btn-sm"
                @click="removeDocument(index)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </table>
      </div>
      <button class="btn btn-info btn-sm" @click="addDocument()" v-if="!edit_document">
        {{ $t("message.account.add_document") }}
      </button>
      <button class="btn btn-info btn-sm" @click="saveDocument()" v-else>
        {{ $t("message.account.add_document") }}</button><br /><br />
    </b-modal>
    <b-modal id="modal-bank-pre-contracts" centered :hide-footer="true" :title="$t('message.account.pre_contracts')"
      size="xl">
      <b-table v-if="bank_pre_contracts.contracts.length > 0" id="bank-pre-contracts-table" responsive
        :items="bank_pre_contracts.contracts" :fields="bank_pre_contracts.fields"
        :per-page="bank_pre_contracts.per_page" :current-page="bank_pre_contracts.current_page">
        <template v-slot:cell(attis_contract_contragent_name)="data">
          <span v-if="data.value != '-10'">{{ data.value }}</span>
        </template>
        <template v-slot:cell(view_contract)="data">
          <button @click="$router.push({ name: 'contracts-single-signed', params: { id: data.item.id } })"
            class="btn btn-sm btn-link">
            <i class="fa fa-solid fa-eye"></i>
          </button>
        </template>
      </b-table>
      <div class="d-flex justify-content-center">
        <b-pagination v-if="bank_pre_contracts.contracts.length > 0" v-model="bank_pre_contracts.current_page"
          :total-rows="bank_pre_contracts.contracts.length" :per-page="bank_pre_contracts.per_page"
          aria-controls="bank-pre-contracts-table"></b-pagination>
      </div>
    </b-modal>
    <b-modal id="modal-document-person" centered :hide-footer="true"
      :title="$t('message.account.documents_of_company')">
      <div class="form-group">
        <!-- <label for="document_types">{{$t('message.contracts.document_types')}}</label> -->
        <!-- <v-select id="document_types" :options="pa_document_types" label="display_text" :class="['form-control', typeof new_document_person.document_type_current !== 'undefined' && new_document_person.document_type_current !==''?'vs--selected':'']" @search=fetchDocumentTypes v-model="new_document_person.document_type_current"></v-select> -->
        <v-select-popup type="pa_document_types" v-model="new_document_person.document_type_current"
          :placeholder="$t('message.contracts.document_types')" />
      </div>
      <div class="form-group">
        <label for="document_number">{{
          $t("message.account.document_number")
        }}</label>
        <input type="text" id="document_number" class="form-control" v-model="new_document_person.document_number" />
      </div>
      <div class="form-group">
        <label for="document_serial">{{
          $t("message.account.document_serial")
        }}</label>
        <input type="text" id="document_serial" class="form-control" v-model="new_document_person.document_serial" />
      </div>
      <div class="form-group">
        <datepicker @focus="new_document_person.document_date = ' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="
          new_document_person.document_date == ' '
            ? (new_document_person.document_date = '')
            : (new_document_person.document_date =
              new_document_person.document_date)
          " inputClass="form-control" v-model="new_document_person.document_date"
          :placeholder="$t('message.account.document_date')" :inputAttr="{ id: 'document_date' }" />
        <!-- <b-form-datepicker :locale="locale" v-model="new_document_person.document_date" :placeholder="$t('message.account.document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_date"></b-form-datepicker> -->
        <label v-if="new_document_person.document_date != ''" for="document_date"
          class="form-label-group-label shorter topped">{{ $t("message.contracts.document_date") }}</label>
      </div>
      <div class="form-group">
        <datepicker @focus="new_document_person.document_exp_date = ' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY"
          @blur="
            new_document_person.document_exp_date == ' '
              ? (new_document_person.document_exp_date = '')
              : (new_document_person.document_exp_date =
                new_document_person.document_exp_date)
            " inputClass="form-control" v-model="new_document_person.document_exp_date"
          :placeholder="$t('message.account.document_exp_date')" :inputAttr="{ id: 'document_exp_date' }" />
        <!-- <b-form-datepicker :locale="locale" v-model="new_document_person.document_exp_date" :placeholder="$t('message.account.document_exp_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_exp_date"></b-form-datepicker> -->
        <label v-if="new_document_person.document_exp_date != ''" for="document_exp_date"
          class="form-label-group-label shorter topped">{{ $t("message.account.document_exp_date") }}</label>
      </div>
      <div class="form-group">
        <label for="document_issued_by">{{
          $t("message.account.document_issued_by")
        }}</label>
        <input type="text" id="document_issued_by" class="form-control"
          v-model="new_document_person.document_issued_by" />
      </div>
      <div class="togglebutton mt-md-3 form-label-group">
        <label class="control-label-sm">
          <span>{{ $t("message.account.document_active") }}</span><br /><br />
          <input type="checkbox" v-model="new_document_person.is_active" />
          <span class="toggle"></span>
          <span class="female">{{ $t("message.yes") }}</span>
          <span class="male">{{ $t("message.no") }}</span>
        </label>
      </div>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="new_document_person.file.id != ''">
        {{ $t("message.contracts.document_file") }}:
        <a target="_blank" :href="'/document/getfile/' + new_document_person.file.id">{{ new_document_person.file.name
          }}</a>
        <button class="btn btn-link text-danger btn-sm" @click="removeFilePerson()">
          <i class="fa fa-trash"></i>
        </button>
      </span>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="new_document_person.file.id == ''">
        <input type="file" class="form-control" :placeholder="$t('message.contracts.document_file')" autocomplete="off"
          style="cursor: auto" id="document_file" @change="fileSelectedPerson($event)" />
        <label for="document_file" class="form-label-group-label shorter pb-0">{{ $t("message.contracts.document_file")
          }}</label>
      </span>
      <div class="table table-responsive">
        <table class="table">
          <thead>
            <th>{{ $t("message.contracts.document_types") }}</th>
            <th>{{ $t("message.account.document_number") }}</th>
            <th>{{ $t("message.account.document_date") }}</th>
            <th>{{ $t("message.account.document_exp_date") }}</th>
            <th></th>
          </thead>
          <tr v-for="(doc, index) in person_documents" :key="index">
            <td :title="doc.document_type">
              {{ display_text_value(doc.document_type) }}
            </td>
            <td :title="doc.document_number">{{ doc.document_number }}</td>
            <td :title="doc.document_date">{{ doc.document_date }}</td>
            <td :title="doc.document_exp_date">{{ doc.document_exp_date }}</td>
            <td>
              <button class="btn btn-link text-info btn-sm" @click="editPersonDocument(index)">
                <i class="fa fa-edit"></i></button><button class="btn btn-link text-danger btn-sm"
                @click="removePersonDocument(index)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </table>
      </div>
      <button class="btn btn-info btn-sm" @click="addPersonDocument()" v-if="!edit_document_person">
        {{ $t("message.account.add_document") }}
      </button>
      <button class="btn btn-info btn-sm" @click="savePersonDocument()" v-else>
        {{ $t("message.account.add_document") }}</button><br /><br />
    </b-modal>
    <b-modal id="modal-select-ecp-type" :hide-footer="true" size="sm" :title="$t('message.contracts.select_ecp_type')">
      <div class="text-center" v-if="!show_code_sign_type">
        <button class="btn btn-outline-success btn-round" @click="submit_and_sign()">
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button class="btn btn-outline-success btn-round" @click="sign_with_code()">
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input type="text" class="form-control" id="input-code" v-model="sign_with_code_code" />
        </div>
        <button class="btn btn-success btn-round" :class="['btn btn-success btn-round', loading_sign ? 'pl-5' : '']"
          :disabled="sign_with_code_code.length == 0" @click="sign_with_code_phase2()">
          <div class="loading my-1 loading-button" v-if="loading_sign"></div>
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button class="btn btn-default btn-round btn-sm" @click="show_code_sign_type = false">
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
    <!-- <div class="container mt-5"  v-if="!is_user_privileged">
			<a href="https://www.atb.su/business/servisy-ved/" target="_blank" class="d-block overflow-hidden rounded">
				<img src="../homepage/assets/img/banner-atb.png" alt="Стань клиентом Азиатско-Тихоокеанского Банка (АО) и получи льготные тарифы на услуги АТТИС" class="d-block w-100">
			</a>
		</div> -->
  </div>
</template>
<script>
import moment from "moment";
import ClasterSelector from "./../fields/claster-selector.vue";
import AllOffers from "./offers.vue";
import team from "./team.vue";
import teamAnalytics from "./team-analytics.vue";
export default {
  name: "account",
  components: {
    ClasterSelector,
    AllOffers,
    team,
    teamAnalytics,
  },
  data() {
    return {
      user_balance: 0,

      offer_link_url: "",
      current_edit_insurer_request: {},
      current_insurance_request_insurer_id: "",
      edit_insurer_request: false,
      insurer_submit_details: false,
      insurer_submit_details_price: "",
      insurer_submit_details_franchise: "",

      current_address_tab: 0,

      show_validation: false,
      show_banks_error: false,
      show_founder_error: false,
      founder_error_text: { Text: "", Level: "Предупреждение" },
      banks_error_text: { Text: "", Level: "Предупреждение" },
      validation_errors: [],

      cert_start_date: "",
      end_start_date: "",
      cert_exists: false,
      cert_bin: "",

      show: 0,
      edit_person: false,
      edit_company: false,
      view_offers: false,
      edit_document: false,
      edit_document_person: false,
      edit_bank: false,
      edit_founder: false,

      loading_map_company: false,
      loading_map: false,
      wrong_old_password: false,
      insecure_new_password: false,
      short_new_password: false,

      countries: [],
      okeds: [],
      statuses: [],
      currencies: [],
      banks: [],
      org_types: [],
      autocompleteitems: [],
      organization_kpveds: "",
      organization_kpveds_tags: [],
      pa_document_types: [],
      map: null,
      map_company: null,
      map_point: null,
      map_point_company: null,
      timeout: null,

      old_password: "",
      new_password: "",
      confirm_password: "",

      subj_bank_accounts: [],
      company_documents: [],
      person_documents: [],
      organizations_founders: [],

      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },

      organization: {},
      person: {},
      residency: {},

      socials: {
        skype: "",
        linkedin: "",
        fb: "",
        instagram: "",
        vk: "",
        wechat: "",
      },
      socials_person: {
        skype: "",
        linkedin: "",
        fb: "",
        instagram: "",
        vk: "",
        wechat: "",
      },

      address_1: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },
      address_2: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },
      address_3: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },

      new_bank: {
        subj_bank: { value: "", display_text: "" },
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      },
      new_founder: {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      },
      new_document: {
        document_type_current: { value: "", display_text: "" },
        document_number: "",
        document_serial: "",
        document_date: "",
        document_exp_date: "",
        document_issued_by: "",
        is_active: "",
        id: "",
        file: { id: "", name: "", date: "" },
      },
      new_document_person: {
        document_type_current: { value: "", display_text: "" },
        document_number: "",
        document_serial: "",
        document_date: "",
        document_exp_date: "",
        document_issued_by: "",
        is_active: "",
        id: "",
        file: { id: "", name: "", date: "" },
      },

      //insurance requests
      current_insurance_request: {
        contract_id: { value: "" },
        org_name: "",
        ceo_name: "",
        statute: null,
        registration_certificate: null,
        signature_right_certificate: null,
        ceo_passport: null,
      },
      contract_id_focus: false,
      contracts: [],
      add_insurance_request: false,
      edit_insurance_requst: false,

      show_broker_request: false,
      broker_offers: [],
      product_fields: [
        {
          key: "attis_cg_TNVED",
          label: this.$t("message.contracts.product_sku"),
          sortable: true,
        },
        {
          key: "attis_cg_good_name",
          label: this.$t("message.contracts.product_title"),
          sortable: true,
        },

        // {
        // 	key: 'ved',
        // 	label: this.$t('message.contracts.product_ved'),
        // 	sortable: true
        // },
        // {
        // 	key: 'attis_cg_quantity',
        // 	label: this.$t('message.contracts.product_qty'),
        // 	sortable: true
        // },
        // {
        // 	key: 'units',
        // 	label: this.$t('message.contracts.product_units'),
        // 	sortable: true
        // },
        {
          key: "attis_cg_price",
          label: this.$t("message.contracts.product_unit_price"),
          sortable: true,
        },
      ],
      current_broker_offer: {},
      broker_offers_fields: [
        {
          key: "view",
          label: this.$t("message.contracts.view"),
        },
        {
          key: "countragent_2.org_name",
          label: this.$t("message.contracts.broker"),
        },
        {
          key: "epi_price",
          label: this.$t("message.contracts.epi_price"),
        },
        {
          key: "td_price",
          label: this.$t("message.contracts.td_price"),
        },
        {
          key: "offer_date",
          label: this.$t("message.contracts.offer_date"),
        },
      ],
      insurer_list_fields: [
        {
          key: "id",
          label: "#",
        },
        {
          key: "insurer_name",
          label: this.$t("message.account.insurers_list_insurer_name"),
        },
        {
          key: "insurer_orgname",
          label: this.$t("message.account.insurers_list_insurer_orgname"),
        },
        {
          key: "insurer_message",
          label: this.$t("message.account.insurers_list_insurer_message"),
        },
        {
          key: "status",
          label: this.$t("message.account.insurers_list_insurer_status"),
        },
        {
          key: "prices",
          label: this.$t(
            "message.account.insurers_list_insurer_price_franchise",
          ),
        },
        {
          key: "actions",
          label: "",
        },
      ],

      all_insurance_requests: [
        // 				{
        // "id": "12",
        // "contract_id": 58,
        // "org_name": "Coke",
        // "ceo_name": "John Doe",
        // "status": "returned",
        // "insurer_message": "Wrong filename", //the message sent by insurer in case the request is returned to user to reupload some documents.
        // "user_id": "asdfasdf21312", //user, who has created the request
        // "org_code": 112312313, //bin of the company of the user who has created the request
        // "statute": "/get_file/212",
        // "registration_certificate": "/get_file/213",
        // "signature_right_certificate": "/get_file/214",
        // "ceo_passport": "/get_file/215",
        // 		}
      ],
      my_insurance_requests: [
        // 				{
        // "ID": "12",
        // "contract_id": 58,
        // "org_name": "Coke",
        // "ceo_name": "John Doe",
        // "status": "returned",
        // "insurer_message": "Wrong filename", //the message sent by insurer in case the request is returned to user to reupload some documents.
        // "user_id": "asdfasdf21312", //user, who has created the request
        // "org_code": 112312313, //bin of the company of the user who has created the request
        // "statute": "/get_file/212",
        // "registration_certificate": "/get_file/213",
        // "signature_right_certificate": "/get_file/214",
        // "ceo_passport": "/get_file/215",
        // 		}
      ],

      insurance_requests_fields: [
        { key: "id", label: "ID" },
        { key: "org_name", label: this.$t("message.account.org_name") },
        { key: "ceo_name", label: this.$t("message.account.ceo_name") },
        // {key: 'status', label: this.$t('message.account.status')},
        { key: "amount", label: this.$t("message.account.amount") },
        { key: "date_time", label: this.$t("message.account.date_time") },
        {
          key: "insurance_type",
          label: this.$t("message.account.insurance_type"),
        },
        { key: "action", label: " " },
      ],
      insurance_requests_fields_all: [
        { key: "id", label: "ID" },
        { key: "org_name", label: this.$t("message.account.org_name") },
        { key: "ceo_name", label: this.$t("message.account.ceo_name") },
        { key: "status", label: this.$t("message.account.status") },
        { key: "amount", label: this.$t("message.account.amount") },
        { key: "date_time", label: this.$t("message.account.date_time") },
        {
          key: "insurance_type",
          label: this.$t("message.account.insurance_type"),
        },
        {
          key: "select_status",
          label: this.$t("message.account.insurers_list_insurer_select_status"),
        },
        { key: "action", label: " " },
      ],
      show_insurance_request: false,
      accept_insurance_request: false,
      return_insurance_request: false,
      show_code_sign_type: false,
      sign_with_code_code: "",
      loading_sign: false,

      current_insurance_request_index: -1,

      bank_pre_contracts: {
        per_page: 7,
        current_page: 0,
        contracts: [],
        fields: [
          {
            key: "attis_contract_number",
            label: this.$t("message.contracts.number"),
            sortable: true,
          },
          {
            key: "attis_contract_date",
            label: this.$t("message.contracts.date"),
            sortable: true,
          },
          {
            key: "owner_org_name",
            label: this.$t("message.contracts.owner"),
            sortable: true,
          },
          {
            key: "attis_contract_contragent_name",
            label: this.$t("message.contracts.contragent"),
            sortable: true,
          },

          {
            key: "attis_contract_subject",
            label: this.$t("message.contracts.title"),
            sortable: true,
          },
          {
            key: "attis_contract_amount",
            label: this.$t("message.contracts.amount"),
            sortable: true,
          },
          {
            key: "attis_contract_currency",
            label: this.$t("message.contracts.currency"),
            sortable: true,
          },
          {
            key: "view_contract",
            label: "",
            sortable: false,
            tdClass: "text-right",
          },
        ],
      },
    };
  },
  mounted() {
    axios.get(window.base + "/account/balance").then((response) => {
      this.user_balance = parseFloat(response.data);
    });
    this.fetchOrgTypes("");
    this.fetchCountries("");
    this.fetchCurrency("");
    this.fetchDocumentTypes("");
    this.fetchOkeds("");
    this.fetchStatuses("");
    this.offer_link_url = "";
    axios.get(window.base + "/admin/getActiveOffer").then((response) => {
      this.offer_link_url = response.data;
    });
    this.load_signature_details();

    this.load();

    this.$root.$on("change-avatar", (data) => {
      this.person.avatar = data.avatar;
    });
    this.$root.$on("change-logo", (data) => {
      this.organization.logo = data.logo;
    });

    window.addEventListener("resize", () => {
      setTimeout(() => {
        try {
          this.showMap();
          this.showMapCompany();
        } catch (e) {
          console.log("map loading error...");
        }
      }, 1000);
    });
    this.$root.$on("screen-resize", (is_expand) => {
      setTimeout(() => {
        try {
          this.showMap();
          this.showMapCompany();
        } catch (e) {
          console.log("map loading error...");
        }
      }, 1000);
    });
    this.$root.$on("insurance-saved", () => {
      this.update_insurer_from_the_list();
    });

    if (this.$route.name == "view-insurance-request") {
      this.show = 2;
      let modal = "modal-insurance_requests";
      if (this.is_insurer) {
        modal = "modal-insurance_requests-insurer";
        this.show_insurance_request = false;
        axios
          .get(window.base + "/account/load_all_insurance_requests")
          .then((response) => {
            this.all_insurance_requests = response.data;

            this.current_insurance_request =
              this.all_insurance_requests[
              this.all_insurance_requests.findIndex(
                (item) => item.id == this.$route.params.id,
              )
              ];
            if (typeof this.current_insurance_request != "undefined") {
              this.$bvModal.show(modal);
              this.show_insurance_request = true;
            }
          });
      } else {
        this.add_insurance_request = false;
        axios
          .get(window.base + "/account/load_my_insurance_requests")
          .then((response) => {
            this.my_insurance_requests = response.data;
            this.current_insurance_request_index =
              this.my_insurance_requests.findIndex(
                (item) => item.id == this.$route.params.id,
              );
            this.current_insurance_request =
              this.my_insurance_requests[this.current_insurance_request_index];
            if (typeof this.current_insurance_request != "undefined") {
              this.$bvModal.show(modal);
              this.add_insurance_request = true;
            }
          });
      }
    }
  },
  computed: {
    is_full() {
      if (["full", "full-mac"].includes(process.env.VUE_APP_MODE)) {
        return true
      }
      return false
    },
    userRole16() {
      return this.$store.state.user.role_id == 16;
    },
    is_user_privileged() {
      return this.$store.state.user.is_privileged;
    },
    formatted_balance() {
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
      }).format(this.user_balance);
    },
    /**
     * determines if current user is insurer or not
     */
    is_twh() {
      // return true
      let has_role = false;
      if (window.dev_mode) has_role = true;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "twh") has_role = true;
      });
      if (!has_role && this.$store.state.user.role_id == 8) has_role = true;
      return has_role;
    },
    /**
     * determines if current user is insurer or not
     */
    is_insurer() {
      // return true
      let has_role = false;
      if (window.dev_mode) has_role = true;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "insurer") has_role = true;
      });
      return has_role;
    },
    /**determines if current user is admin */
    is_admin() {
      let has_role = false;
      if (window.dev_mode) has_role = true;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "admin") has_role = true;
      });
      return has_role;
    },
    /**determines if current user is broker */
    is_broker() {
      let has_role = false;
      if (window.dev_mode) has_role = true;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "broker") has_role = true;
      });
      return has_role;
    },
    /**
     * determines if the certificate date is not expired
     */
    cert_valid() {
      let date = moment(this.end_start_date, "DD.MM.YYYY HH:mm");
      return date.diff(moment()) > 0;
    },
    url() {
      return window.base + "/picture/avatar_upload";
    },
    url_company() {
      return window.base + "/picture/logo_upload";
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
  },
  methods: {
    /**
     * determines the classname for the grid row to highlight selected rows
     */
    rowClass(item) {
      if (this.is_selected) {
        if (item.is_selected) return "bg-success-light";
        else {
          if (item.is_accepted) return "text-line-through bg-success-light";
          else return "text-line-through";
        }
      } else if (item.is_accepted) return "bg-success-light";
      return "";
    },
    /**
     * displays human-readable currency
     */
    showCurrency(currency) {
      // return ''
      // console.log(this.currencies)
      var index = this.currencies.findIndex((i) => i.value == currency);
      if (index > -1) return this.currencies[index].display_text;
      return "";
    },
    /**
     * opens broker offer to view
     */
    openBrokerOffer(offer) {
      this.show_broker_request = true;
      this.current_broker_offer = offer;
    },
    /**
     * Initializes electorinc signature for the contract.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    submit_and_sign() {
      // if(typeof this.attis_contracts.attis_contract_contragent.value !== 'undefined' && this.attis_contracts.attis_contract_contragent.value != '')
      // {
      this.loading = true;
      axios
        .get(
          window.base +
          "/account/get_insurance_contract_xml?id=" +
          this.current_insurance_request_insurer_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            // window.getKeyInfo('PKCS12', "getKeyInfoBack");
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => { });
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            // window.signXml("PKCS12", "SIGNATURE", this.xml, ()=>{
            // });
            // return true;
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              // console.log(rw)
              if (rw.code == "200") {
                console.log(result);
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    let name = response.data.cert_name;
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      fd.append(
                        "request_id",
                        this.current_insurance_request_insurer_id,
                      );
                      fd.append("signature", value);
                      fd.append("signature_name", name);
                      fd.append("sign_name", name);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base +
                          "/account/sign_insurance_offer?id=" +
                          this.current_insurance_request_insurer_id,
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.fetchForAcoountInsurance();
                          this.current_insurance_request.insurers.forEach(
                            (i, ind) => {
                              if (
                                i.id ==
                                this.current_insurance_request_insurer_id
                              )
                                this.$set(
                                  this.current_insurance_request.insurers[ind],
                                  "is_signed",
                                  true,
                                );
                            },
                          );
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.contract_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                          // this.$router.push({name: 'contracts-single-signed', params: {id: this.$route.params.id}})
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.contract_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.contract_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                window.webSocket.removeEventListener("message", {});
                window.webSocket.close();
              }
            }
          };
        });
      // }
      // else {
      // 	this.loading = false
      // 	this.loading_sign = false
      // 	new Noty({
      // 		theme: 'light',
      // 		type: 'error',
      // 		text: this.$t('message.message.signature_no_contragent')+' ('+e+')',
      // 		timeout: 5000,
      // 	}).show();
      // 	this.$bvModal.hide('modal-select-ecp-type')
      // }
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in contract
     */
    sign_with_code_phase2() {
      // if(typeof this.attis_contracts.attis_contract_contragent.value !== 'undefined' && this.attis_contracts.attis_contract_contragent.value != '')
      // {
      if (this.sign_with_code_code != "") {
        this.loading_sign = true;
        axios
          .get(
            window.base +
            "/account/get_insurance_contract_xml?id=" +
            this.current_insurance_request_insurer_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", window.Base64.encode(xml));
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                if ("token invalid" === response.data) {
                  this.show_code_sign_type = false;
                  new Noty({
                    theme: "light",
                    type: "error",
                    text:
                      this.$t("message.message.contract_not_signed") +
                      " (" +
                      response.data +
                      ")",
                    timeout: 5000,
                  }).show();
                } else {
                  var fd = new FormData();
                  fd.append(
                    "request_id",
                    this.current_insurance_request_insurer_id,
                  );
                  fd.append("signature", response.data);
                  fd.append("type", "code");
                  axios
                    .post(
                      window.base +
                      "/account/sign_insurance_offer?id=" +
                      this.current_insurance_request_insurer_id,
                      fd,
                    )
                    .then(() => {
                      this.loading = false;
                      this.show_code_sign_type = false;
                      this.loading_sign = false;
                      this.sign_with_code_code = "";
                      this.load(); //refresh status of the contract
                      new Noty({
                        theme: "light",
                        type: "success",
                        text: this.$t("message.message.contract_signed"),
                        timeout: 5000,
                      }).show();
                      this.$bvModal.hide("modal-select-ecp-type");
                    })
                    .catch((e) => {
                      this.loading = false;
                      this.loading_sign = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text:
                          this.$t("message.message.contract_not_signed") +
                          " (" +
                          e +
                          ")",
                        timeout: 5000,
                      }).show();
                      this.$bvModal.hide("modal-select-ecp-type");
                    });
                }
              })
              .catch((e) => {
                this.loading = false;
                this.loading_sign = false;
                new Noty({
                  theme: "light",
                  type: "error",
                  text:
                    this.$t("message.message.contract_not_signed") +
                    " (" +
                    e +
                    ")",
                  timeout: 5000,
                }).show();
                this.$bvModal.hide("modal-select-ecp-type");
              });
          });
      }
      // }
      // else {
      // 	this.loading = false
      // 	this.loading_sign = false
      // 	new Noty({
      // 		theme: 'light',
      // 		type: 'error',
      // 		text: this.$t('message.message.signature_no_contragent')+' ('+e+')',
      // 		timeout: 5000,
      // 	}).show();
      // 	this.$bvModal.hide('modal-select-ecp-type')
      // }
    },
    /**
     * Sends request to backend to send a code to sign a contract without ECP
     */
    sign_with_code() {
      axios
        .get(
          window.base +
          "/account/GenerateToken?doc_id=" +
          this.current_insurance_request_insurer_id,
        )
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    insurer_submit_details_to_request() {
      axios
        .post(
          window.base +
          "/account/attach_contract_to_insurance_offer?request_id=" +
          this.current_insurance_request.id +
          "&price=" +
          this.insurer_submit_details_price +
          "&franchise=" +
          this.insurer_submit_details_franchise,
        )
        .then(() => {
          this.insurer_submit_details = false;
          this.current_insurance_request.offer_sent = true;
        });
    },
    sign_insurer_from_the_list(insurer) {
      this.$bvModal.show("modal-select-ecp-type");
      this.current_insurance_request_insurer_id = insurer.id;
    },
    handle_file_upload_edit_request(event, type) {
      this.current_edit_insurer_request.type = event.target.files[0];
    },
    edit_insurer_from_the_list(insurer) {
      this.current_edit_insurer_request = insurer;
      this.current_edit_insurer_request.amount =
        this.current_insurance_request.amount;
      this.current_edit_insurer_request.org_name =
        this.current_insurance_request.org_name;
      this.current_edit_insurer_request.ceo_name =
        this.current_insurance_request.ceo_name;
      this.edit_insurer_request = true;
    },
    update_insurer_from_the_list() {
      if (
        typeof this.current_edit_insurer_request.insurer_request_id !==
        "undefined"
      ) {
        let fd = new FormData();
        fd.append("contract_id", this.current_insurance_request.contract_id);
        fd.append("org_name", this.current_edit_insurer_request.org_name);
        fd.append("ceo_name", this.current_edit_insurer_request.ceo_name);
        fd.append("document_id", this.current_insurance_request.document_id);
        fd.append("statute", this.current_edit_insurer_request.statute);
        fd.append(
          "registration_certificate",
          this.current_edit_insurer_request.registration_certificate,
        );
        fd.append(
          "signature_right_certificate",
          this.current_edit_insurer_request.signature_right_certificate,
        );
        fd.append(
          "ceo_passport",
          this.current_edit_insurer_request.ceo_passport,
        );
        fd.append(
          "insurance_type",
          this.current_insurance_request.insurance_type,
        );
        fd.append("amount", this.current_insurance_request.amount);
        axios
          .post(
            window.base +
            "/update_insurance_request?id=" +
            this.current_edit_insurer_request.insurer_request_id,
            fd,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            this.edit_insurer_request = false;
          });
      }
    },
    /**
     * selects insurer from the list of insurers in contragent1 insurance request
     */
    select_insurer_from_the_list(insurer) {
      axios
        .post(window.base + "/account/select_insurance_offer", {
          insurer_id: [insurer.insurer_id],
          request_id: insurer.insurer_request_id,
        })
        .then((response) => {
          if (
            typeof response.data.status !== "undefined" &&
            response.data.status == "ok"
          ) {
            this.sign_insurer_from_the_list(insurer);
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
          }
        });
    },
    /**
     * accepts insurance request
     */
    acceptInsuranceRequest() {
      let fd = new FormData();
      fd.append("request_id", this.current_insurance_request.id);
      fd.append("certificate", this.current_insurance_request.certificate);

      axios
        .post(
          window.base +
          "/account/approve_insurance_request?request_id=" +
          this.current_insurance_request.id,
          fd,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((response) => {
          if (response.data.status == "ok") {
            this.show_insurance_request = false;
            this.accept_insurance_request = false;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.success"),
              timeout: 5000,
            }).show();
            this.insurer_submit_details_to_request();
            this.fetchForAcoountInsuranceInsurer();
          } else {
            this.show_insurance_request = false;
            this.accept_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.fetchForAcoountInsuranceInsurer();
          }
        })
        .catch((e) => {
          this.show_insurance_request = false;
          this.accept_insurance_request = false;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.no_success"),
            timeout: 5000,
          }).show();
          this.fetchForAcoountInsuranceInsurer();
        });
    },
    /**
     * declines insurance request
     */
    returnInsuranceRequest() {
      let fd = new FormData();
      fd.append("request_id", this.current_insurance_request.id);
      fd.append("message", this.current_insurance_request.insurer_message);

      axios
        .post(
          window.base +
          "/account/request_docs_for_insurance_request?request_id=" +
          this.current_insurance_request.id,
          fd,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((response) => {
          if (response.data.status == "ok") {
            this.show_insurance_request = false;
            this.return_insurance_request = false;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.success"),
              timeout: 5000,
            }).show();
            this.fetchForAcoountInsuranceInsurer();
          } else {
            this.show_insurance_request = false;
            this.return_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.fetchForAcoountInsuranceInsurer();
          }
        })
        .catch((e) => {
          this.show_insurance_request = false;
          this.return_insurance_request = false;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.no_success"),
            timeout: 5000,
          }).show();
          this.fetchForAcoountInsuranceInsurer();
        });
    },
    /**
     * opens approve/return insurance request form
     */
    showInsuranceRequest(inurance_request) {
      this.current_insurance_request = inurance_request;
      this.show_insurance_request = true;
    },
    /**
     * opens edit insurance request form
     */
    editInsuranceRequest(inurance_request, index) {
      this.current_insurance_request = inurance_request;
      this.current_insurance_request.contract_id =
        this.contracts[
        this.contracts.findIndex(
          (item) => item.value == inurance_request.contract_id,
        )
        ];
      this.add_insurance_request = true;
      this.edit_insurance_requst = true;

      this.current_insurance_request_index = index;
    },
    /**
     * SAVES/updates insurance requests
     */
    saveInsuranceRequest() {
      let fd = new FormData();
      fd.append(
        "contract_id",
        this.current_insurance_request.contract_id.value,
      );
      fd.append("org_name", this.current_insurance_request.org_name);
      fd.append("ceo_name", this.current_insurance_request.ceo_name);
      fd.append("statute", this.current_insurance_request.statute);
      fd.append(
        "registration_certificate",
        this.current_insurance_request.registration_certificate,
      );
      fd.append(
        "signature_right_certificate",
        this.current_insurance_request.signature_right_certificate,
      );
      fd.append("ceo_passport", this.current_insurance_request.ceo_passport);

      if (this.edit_insurance_requst) {
        // account/create_insurance_request
        fd.append("request_id", this.current_insurance_request.id);
        axios
          .post(
            window.base +
            "/account/update_insurance_request?request_id=" +
            this.current_insurance_request.id,
            fd,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            if (response.data.status == "ok") {
              this.add_insurance_request = false;
              this.edit_insurance_requst = false;
              new Noty({
                theme: "light",
                type: "success",
                text: this.$t("message.message.success"),
                timeout: 5000,
              }).show();
              this.fetchForAcoountInsurance();
            } else {
              this.add_insurance_request = false;
              this.edit_insurance_requst = false;
              new Noty({
                theme: "light",
                type: "error",
                text: this.$t("message.message.no_success"),
                timeout: 5000,
              }).show();
              this.fetchForAcoountInsurance();
            }
          })
          .catch((e) => {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.fetchForAcoountInsurance();
          });
      } else {
        axios
          .post(window.base + "/account/create_insurance_request", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.status == "ok") {
              this.add_insurance_request = false;
              new Noty({
                theme: "light",
                type: "success",
                text: this.$t("message.message.success"),
                timeout: 5000,
              }).show();
              this.fetchForAcoountInsurance();
            } else {
              this.add_insurance_request = false;
              new Noty({
                theme: "light",
                type: "error",
                text: this.$t("message.message.no_success"),
                timeout: 5000,
              }).show();
              this.fetchForAcoountInsurance();
            }
          })
          .catch((e) => {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.fetchForAcoountInsurance();
          });
      }
    },
    /**
     * hides add insurance request form
     */
    cancelAddInsurance() {
      this.add_insurance_request = false;
      this.edit_insurance_requst = false;
      this.edit_insurer_request = false;
      this.current_insurance_request_index = -1;
    },
    /**
     * handles file select event
     */
    fileHandleInsurance(event, type) {
      this.current_insurance_request[type] = event.target.files[0];
    },
    /**
     * Shows insurance request add form
     */
    addInsuranceRequest() {
      // this.loadMyContracts()
      this.add_insurance_request = true;
    },
    /**
     * loads list of my contracts for insurance request
     */
    loadMyContracts() {
      axios
        .get(window.base + "/contract?customer_id=" + this.$store.state.user.id)
        .then((response) => {
          // change [0] to [1]
          this.contracts = response.data[1].contracts.map((item) => {
            let item_ = {};
            item_.value = item.id;
            item_.display_text = item.id + ": " + item.attis_contract_subject;
            return item_;
          });
        });
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        post_addr_index: "address_index_",
        post_addr_country: "address_country",
        post_addr_region: "address_region_",
        post_addr_district: "address_district_",
        post_addr_town: "address_town_",
        post_addr_city: "address_city_",
        post_addr_streethouse: "address_street_",
        post_addr_house: "address_house_",
        post_addr_room: "address_room_",

        company_contacts: "company_contacts",
        org_name: "org_name",
        org_oked: "org_oked",
        org_type: "org_type",
        org_residency: "org_residency",

        residency: "residency",
        //add other field names in format data-name: field_id
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_field(error) {
      this.show_banks_error = false;
      this.show_founder_error = false;
      switch (error.Subsection) {
        case "Contract":
          switch (error.Value) {
            case "attis_cg_contract_id":
              this.showAddProduct();
              setTimeout(() => {
                var element = document.querySelector(".add-product-block");
                console.log(element);
                var element_pos = this.findPos(element);
                console.log(element_pos);
                window.scrollTo(0, element_pos.Y - 50);
              }, 500);
              break;
            case "attis_contract_contragent":
              var element = document.querySelector("#" + error.Value);
              var element_pos = this.findPos(element);
              // element.parentNode.classList.add('error')
              element.focus();
              window.scrollTo(0, element_pos.Y - 50);
              break;
            case "attis_contract_subject":
              var element = document.querySelector(
                "#" + this.field_name_replace(error.Value),
              );
              var element_pos = this.findPos(element);
              // element.parentNode.classList.add('error')
              element.focus();
              window.scrollTo(0, element_pos.Y - 50);
              break;
            case "attis_contract_desc":
              var element = document.querySelector(
                "#" + this.field_name_replace(error.Value),
              );
              var element_pos = this.findPos(element);
              // element.parentNode.classList.add('error')
              element.focus();
              window.scrollTo(0, element_pos.Y - 50);
              break;
          }
          break;
        case "CompanyAdress":
          //at the start we only have a company address validation
          //add more cases later, when we have more data validation

          //displays address modal
          this.show = 2;
          this.$bvModal.show("modal-addresses");
          //displays correct tab in the modal
          this.current_address_tab = 0;
          //highlights and focuses the field with error
          setTimeout(() => {
            let element = document.querySelector(
              "#" + this.field_name_replace(error.Value) + "1",
            );
            let element_pos = this.findPos(element);
            element.parentNode.classList.add("error");
            element.focus();
            let div = document.createElement("div");
            div.classList.add("error-description");
            div.innerHTML = error.Text;
            element.parentNode.appendChild(div);
            document
              .querySelector("#modal-addresses")
              .scrollTo(0, element_pos.Y - 50);
          }, 100);
          break;
        case "Bank":
          this.show = 2;
          this.$bvModal.show("modal-account");
          this.show_banks_error = true;
          this.banks_error_text = error;
          break;
        case "Company":
          this.show = 2;
          this.editCompany();
          setTimeout(() => {
            let element = document.querySelector(
              "#" + this.field_name_replace(error.Value),
            );
            let element_pos = this.findPos(element);
            element.parentNode.parentNode.classList.add("error");
            element.focus();
            let div = document.createElement("div");
            div.classList.add("error-description");
            div.innerHTML = error.Text;
            element.parentNode.appendChild(div);
            window.scrollTo(0, element_pos.Y - 50);
          }, 100);
          break;
        case "Founder":
          this.show = 2;
          this.$bvModal.show("modal-founders");
          this.show_founder_error = true;
          this.founder_error_text = error;
          break;
        case "Person":
          this.show = 1;
          this.editPerson();
          setTimeout(() => {
            let element = document.querySelector(
              "#" + this.field_name_replace(error.Value),
            );
            let element_pos = this.findPos(element);
            element.parentNode.parentNode.classList.add("error");
            element.focus();
            let div = document.createElement("div");
            div.classList.add("error-description");
            div.innerHTML = error.Text;
            element.parentNode.appendChild(div);
            window.scrollTo(0, element_pos.Y - 50);
          }, 100);
          break;
      }
    },
    /**
     * returns alert CSS class_name depending on the type of the
     *  validation message
     */
    get_alert_type(error) {
      switch (error.Level) {
        case "Предупреждение":
          return "-warning";
          break;
        case "Ошибка":
          return "-danger";
          break;
        default:
          return "-info";
      }
    },
    /**
     * Runs validation of the data and displays an error dialog in case
     */
    run_validation(event) {
      let button_pos = this.findPos(event.target);
      let validation_frame = document.querySelector(".validation-frame");
      let validation_frame_top = 0;
      if (event.target.offsetWidth + button_pos.X + 300 > window.innerWidth) {
        validation_frame.style.left =
          event.target.offsetWidth + button_pos.X - 300 + "px";
        validation_frame_top = button_pos.Y + event.target.offsetHeight + 10;
        validation_frame.style.top = validation_frame_top + "px";
        validation_frame.style.width = "300px";
        validation_frame.classList.add("top");
        validation_frame.classList.remove("left");
      } else {
        validation_frame.style.left =
          event.target.offsetWidth + button_pos.X + 10 + "px";
        validation_frame_top = button_pos.Y;
        validation_frame.style.top = validation_frame_top + "px";
        validation_frame.style.width = "290px";
        validation_frame.classList.add("left");
        validation_frame.classList.remove("top");
      }
      validation_frame.classList.add("arrow");
      axios
        .get(window.base + "/validate?org_code=" + this.item)
        .then((response) => {
          this.validation_errors = response.data;
          this.show_validation = true;
        });

      window.addEventListener("scroll", () => {
        // console.log(window.scrollY)
        if (window.scrollY > button_pos.Y + event.target.offsetHeight) {
          validation_frame.style.top = "50px";
          validation_frame.classList.remove("arrow");
        } else {
          validation_frame.style.top =
            validation_frame_top - window.scrollY + "px";
          validation_frame.classList.add("arrow");
        }
      });
    },
    /**
     * loads details of the signature (start and end dates)
     */
    load_signature_details() {
      axios
        .get(window.base + "/account/loadSignatureDetails")
        .then((response) => {
          // this.signature_details = response.data
          this.cert_start_date = response.data.start_date;
          this.end_start_date = response.data.end_date;
          this.cert_exists = response.data.cert_exists;
          this.cert_bin = response.data.cert_bin;

          // this.cert_start_date = '20.09.2021 12:00'
          // this.end_start_date = '19.09.2022 12:00'
          // this.cert_exists = true
        });
    },
    /**
     * inits NCALayer to get new signature data and save to database
     */
    add_new_signature() {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.account.change_signature"), {
          title: this.$t("message.confirm"),
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
            window.callback = null;

            window.webSocket.onopen = function (event) {
              console.log("Connection opened");
              window.getKeyInfo("PKCS12", "getKeyInfoBack");
            };

            window.webSocket.onclose = function (event) {
              if (event.wasClean) {
                console.log("connection has been closed");
              } else {
                console.log("Connection error");
                openDialog();
              }
              console.log("Code: " + event.code + " Reason: " + event.reason);
            };
            let el = this;
            window.webSocket.onmessage = function (event) {
              var result = JSON.parse(event.data);
              console.log(result);
              //check BIN
              let m;
              let reg_bin = /=BIN([0-9]{9,14})/;
              let reg_name = /O=(.*),OU/gm;
              if ((m = reg_bin.exec(result["responseObject"]["subjectDn"]))) {
                let bin = m[1];
                let mm = (m = reg_name.exec(
                  result["responseObject"]["subjectDn"],
                ));
                let name = mm[1];
                name = name.replace('\\"', '"').replace('\\"', '"');
                console.log(name);

                axios
                  .get(window.base + "/account/CheckBin?bin=" + bin)
                  .then((response) => {
                    if (response.data == 1) {
                      if (result != null && result["responseObject"].pem) {
                        const regex = /\\n/gm;
                        let cert = result["responseObject"].pem
                          .replace(regex, "")
                          .replace("-----END CERTIFICATE-----", "")
                          .replace("-----BEGIN CERTIFICATE-----", "");
                        let now = Date.now();
                        if (result["responseObject"].certNotBefore > now) {
                          new Noty({
                            theme: "light",
                            type: "error",
                            text: el.$t(
                              "message.account.signature_is_not_valid_yet",
                            ),
                            timeout: 5000,
                          }).show();
                        } else if (
                          result["responseObject"].certNotAfter < now
                        ) {
                          new Noty({
                            theme: "light",
                            type: "error",
                            text: el.$t(
                              "message.account.signature_is_already_not_valid",
                            ),
                            timeout: 5000,
                          }).show();
                        } else {
                          let start_date = moment
                            .unix(result["responseObject"].certNotBefore / 1000)
                            .format("DD.MM.Y");
                          let end_date = moment
                            .unix(result["responseObject"].certNotAfter / 1000)
                            .format("DD.MM.Y");
                          el.cert_start_date = start_date;
                          el.end_start_date = end_date;
                          el.cert_exists = true;
                          let fd = new FormData();
                          fd.append("start_date", start_date);
                          fd.append("end_date", end_date);
                          fd.append("cert", cert);
                          fd.append("cert_bin", bin);
                          fd.append("cert_name", name);
                          axios.post(window.base + "/account/setSignature", fd);
                        }
                      }
                    } else {
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: el.$t(
                          "message.message.signature_bin_is_not_valid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });
              } else {
                new Noty({
                  theme: "light",
                  type: "error",
                  text: el.$t("message.message.signature_bin_is_not_found"),
                  timeout: 5000,
                }).show();
              }
            };
          }
        });
    },
    fileSelected(event) {
      if (typeof event.target.files[0] !== "undefined") {
        if (event.target.files[0].size / 1000000 < 20)
          this.$set(this.new_document, "file", event.target.files[0]);
        else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.file_too_big20"),
            timeout: 5000,
          }).show();
          document.querySelector("#document_file").value = "";
        }
      } else this.new_document.file = false;
    },
    fileSelectedPerson(event) {
      if (typeof event.target.files[0] !== "undefined") {
        if (event.target.files[0].size / 1000000 < 20)
          this.$set(this.new_document_person, "file", event.target.files[0]);
        else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.file_too_big20"),
            timeout: 5000,
          }).show();
          document.querySelector("#document_file").value = "";
        }
      } else this.new_document_person.file = false;
    },
    removeFile() {
      this.new_document.file = { id: "", name: "", date: "" };
    },
    removeFilePerson() {
      this.new_document_person.file = { id: "", name: "", date: "" };
    },
    display_text_value(object) {
      if (
        typeof object !== "undefined" &&
        typeof object.display_text !== "undefined"
      ) {
        return object.display_text;
      }
      return "";
    },
    cloneAddress(direction) {
      if (direction == "post") {
        this.address_2 = { ...this.address_1 };
      }
      if (direction == "fact") {
        this.address_3 = { ...this.address_1 };
      }
    },
    processOrganizationKpveds() {
      var t = this.organization.organization_kpveds;
      axios
        .get(
          window.base +
          "/classification?type=kpved&level=names&query=" +
          t +
          "&qty=10" +
          "&lang=" +
          this.$i18n.locale,
        )
        .then((response) => {
          this.organization_kpveds_tags = _.map(response.data, (i) => {
            return i.display_text;
          });
        });
    },
    empty(string) {
      return _.isEmpty(string);
    },
    addFounder() {
      this.organizations_founders.push({
        org_founders_person_name: this.new_founder.org_founders_person_name,
        org_founders_company: this.new_founder.org_founders_company,
        org_founders_country: this.new_founder.org_founders_country,
        org_founders_share: this.new_founder.org_founders_share,
      });
      this.new_founder = {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      };
    },
    saveFounder() {
      this.edit_founder = false;
      this.new_founder = {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      };
    },
    removeFounder(index) {
      this.organizations_founders.splice(index, 1);
    },
    editFounder(index) {
      this.new_founder = this.organizations_founders[index];
      this.edit_founder = true;
    },
    addBank() {
      this.subj_bank_accounts.push({
        subj_bank: this.new_bank.subj_bank,
        subj_bank_acc_number: this.new_bank.subj_bank_acc_number,
        subj_bank_acc_curr: this.new_bank.subj_bank_acc_curr,
        subj_bank_acc_status: this.new_bank.subj_bank_acc_status,
      });
      this.new_bank = {
        subj_bank: { value: "", display_text: "" },
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      };
    },
    saveBank() {
      this.edit_bank = false;
      this.new_bank = {
        subj_bank: { value: "", display_text: "" },
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      };
    },
    removeBank(index) {
      this.subj_bank_accounts.splice(index, 1);
    },
    editBank(index) {
      this.new_bank = this.subj_bank_accounts[index];
      this.edit_bank = true;
    },
    addDocument() {
      var formdata = new FormData();
      this.new_document.document_type =
        this.new_document.document_type_current.value;
      this.new_document.document_date = this.momentum(
        this.new_document.document_date,
      );
      this.new_document.document_exp_date = this.momentum(
        this.new_document.document_exp_date,
      );
      for (var i in this.new_document) {
        if (i !== "is_active") formdata.append(i, this.new_document[i]);

        formdata.append(
          "is_active",
          this.new_document.is_active === true ? 1 : 0,
        );
      }

      axios
        .post(window.base + "/document/saveCompanyDocument", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.save_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.save_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }
          this.company_documents.push({
            document_type: this.new_document.document_type_current,
            document_number: this.new_document.document_number,
            document_serial: this.new_document.document_serial,
            document_date: this.momentum(this.new_document.document_date),
            document_exp_date: this.momentum(
              this.new_document.document_exp_date,
            ),
            document_issued_by: this.new_document.document_issued_by,
            is_active: this.new_document.is_active,
            file: this.new_document.file,
            id: response.data.id,
          });
          this.new_document = {
            document_type: { value: "", display_text: "" },
            document_number: "",
            document_serial: "",
            document_date: "",
            document_exp_date: "",
            document_issued_by: "",
            is_active: "",
            file: { id: "", name: "", date: "" },
            id: "",
          };
        });
    },
    saveDocument() {
      var formdata = new FormData();
      var doc_tmp = this.new_document;
      this.new_document.document_date = this.momentum(
        this.new_document.document_date,
      );
      this.new_document.document_exp_date = this.momentum(
        this.new_document.document_exp_date,
      );
      for (var i in doc_tmp) {
        if (i !== "is_active" && i !== "document_type")
          formdata.append(i, this.new_document[i]);

        formdata.append(
          "is_active",
          this.new_document.is_active === true ? 1 : 0,
        );
        formdata.append(
          "document_type",
          this.new_document.document_type_current.value,
        );
      }
      axios
        .post(window.base + "/document/saveCompanyDocument", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.update_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.update_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }

          this.edit_document = false;
          this.new_document = {
            document_type: { value: "", display_text: "" },
            document_number: "",
            document_serial: "",
            document_date: "",
            document_exp_date: "",
            document_issued_by: "",
            is_active: "",
            file: { id: "", name: "", date: "" },
            id: "",
          };
        });
    },
    addPersonDocument() {
      var formdata = new FormData();
      this.new_document_person.document_type =
        this.new_document_person.document_type_current.value;
      this.new_document_person.document_date = this.momentum(
        this.new_document_person.document_date,
      );
      this.new_document_person.document_exp_date = this.momentum(
        this.new_document_person.document_exp_date,
      );
      for (var i in this.new_document_person) {
        if (i !== "is_active") formdata.append(i, this.new_document_person[i]);
        formdata.append(
          "is_active",
          this.new_document_person.is_active === true ? 1 : 0,
        );
      }
      axios
        .post(window.base + "/document/savePersonDocument", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.save_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.save_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }
          this.person_documents.push({
            document_type: this.new_document_person.document_type_current,
            document_number: this.new_document_person.document_number,
            document_serial: this.new_document_person.document_serial,
            document_date: this.momentum(
              this.new_document_person.document_date,
            ),
            document_exp_date: this.momentum(
              this.new_document_person.document_exp_date,
            ),
            document_issued_by: this.new_document_person.document_issued_by,
            is_active: this.new_document_person.is_active,
            file: this.new_document_person.file,
            id: response.data.id,
          });
          this.new_document_person = {
            document_type: { value: "", display_text: "" },
            document_number: "",
            document_serial: "",
            document_date: "",
            document_exp_date: "",
            document_issued_by: "",
            is_active: "",
            file: { id: "", name: "", date: "" },
            id: "",
          };
        });
    },
    savePersonDocument() {
      var formdata = new FormData();
      var doc_tmp = this.new_document_person;
      this.new_document_person.document_date = this.momentum(
        this.new_document_person.document_date,
      );
      this.new_document_person.document_exp_date = this.momentum(
        this.new_document_person.document_exp_date,
      );
      for (var i in doc_tmp) {
        if (i !== "is_active" && i !== "document_type")
          formdata.append(i, this.new_document_person[i]);

        formdata.append(
          "is_active",
          this.new_document_person.is_active === true ? 1 : 0,
        );
        formdata.append(
          "document_type",
          this.new_document_person.document_type_current.value,
        );
      }
      axios
        .post(window.base + "/document/savePersonDocument", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.update_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.update_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }
          this.edit_document_person = false;
          this.new_document_person = {
            document_type: { value: "", display_text: "" },
            document_number: "",
            document_serial: "",
            document_date: "",
            document_exp_date: "",
            document_issued_by: "",
            is_active: "",
            file: { id: "", name: "", date: "" },
            id: "",
          };
        });
    },
    removeDocument(index) {
      var removeDoc = this.company_documents[index];
      axios
        .post(window.base + "/document/RemovePADocument?docId=" + removeDoc.id)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.remove_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.remove_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }
          this.company_documents.splice(index, 1);
        });
    },
    removePersonDocument(index) {
      var removeDoc = this.person_documents[index];
      axios
        .post(window.base + "/document/RemovePADocument?docId=" + removeDoc.id)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.remove_pa_doc-ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.remove_pa_doc-nok"),
              timeout: 5000,
            }).show();
          }
          this.person_documents.splice(index, 1);
        });
    },
    editDocument(index) {
      this.new_document = this.company_documents[index];
      this.new_document.document_type_current =
        this.company_documents[index].document_type;
      this.edit_document = true;
    },
    editPersonDocument(index) {
      this.new_document_person = this.person_documents[index];
      this.new_document_person.document_type_current =
        this.person_documents[index].document_type;
      this.edit_document_person = true;
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
          "/library?type=" +
          type +
          "&query=" +
          query +
          "&qty=" +
          qty +
          "&lang=" +
          this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········")
              if (
                type == "oked" ||
                type == "declaration_kind" ||
                type == "goods_transfer_feature"
              ) {
                item.display_text = item.value + " - " + item.display_text;
                this.$data[var_name].push(item);
              } else this.$data[var_name].push(item);
          });
        });
    },
    fetchForAcoount() {
      this.fetchCurrency("");
      this.fetchBank("");
    },
    fetchForAcoountInsurance() {
      this.add_insurance_request = false;
      // this.loadMyContracts()
      axios
        .get(window.base + "/account/load_my_insurance_requests")
        .then((response) => {
          this.my_insurance_requests = response.data;

          if (this.current_insurance_request_index != -1)
            this.current_insurance_request =
              this.my_insurance_requests[this.current_insurance_request_index];
        });
    },
    fetchForAcoountInsuranceInsurer() {
      this.show_insurance_request = false;
      axios
        .get(window.base + "/account/load_all_insurance_requests")
        .then((response) => {
          this.all_insurance_requests = response.data;
        });
    },
    fetchOrgTypes(search, loading) {
      this.getLibrary("org_type", search, 1000000);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 1000000);
    },
    fetchCurrency(search, loading) {
      this.getLibrary("currency", search, 1000000);
    },
    fetchBank(search, loading) {
      this.getLibrary("bank", search, 1000000);
    },
    fetchOkeds(search, loading) {
      this.getLibrary("oked", search, 1000000);
    },
    fetchStatuses(search, loading) {
      this.getLibrary("status", search, 1000000);
    },
    fetchDocumentTypes(search, loading) {
      this.getLibrary("pa_document_type", search, 1000000);
    },
    findLibValue(lib, value, field) {
      if (typeof value == "string") {
        if (typeof lib == "string") {
          this.$set(this.organization, field, { value: "", display_text: "" });
          axios
            .get(
              window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((response) => {
              response.data.forEach((item) => {
                if (item.value.trim() == value.trim()) {
                  item.display_text = item.value + " - " + item.display_text;
                  this.$set(this.organization, field, item);
                }
              });
            });
        } else {
          lib.forEach((item) => {
            if (item.value == value) this.$set(this.ap_main, field, item);
          });
        }
      }
    },
    findLibValuePerson(lib, value, field) {
      if (typeof lib == "string") {
        this.$set(this.person, field, { value: "", display_text: "" });
        axios
          .get(
            window.base +
            "/library?type=" +
            lib +
            "&query=&qty=1000" +
            "&lang=" +
            this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value.trim() == value.trim()) {
                item.display_text = item.value + " - " + item.display_text;
                this.$set(this.person, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.ap_main, field, item);
        });
      }
    },

    load() {
      if (this.$store.state.firmfull == false) {
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.subj_bank_accounts = response.data.banks;
          axios
            .get(
              window.base +
              "/library?type=currency&query=&qty=10000" +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((res) => {
              var currencyList = res.data;
              axios
                .get(
                  window.base +
                  "/library?type=bank&query=&qty=10000" +
                  "&lang=" +
                  this.$i18n.locale,
                )
                .then((res) => {
                  var banksList = res.data;
                  this.subj_bank_accounts.forEach((bnk) => {
                    if (bnk.subj_bank_acc_curr) {
                      var curr = currencyList.filter((obj) => {
                        return (
                          parseInt(obj.value) ===
                          parseInt(bnk.subj_bank_acc_curr)
                        );
                      });
                      bnk.subj_bank_acc_curr = curr[0];
                    }
                    if (bnk.subj_bank) {
                      var bnk1 = banksList.filter((obj) => {
                        return obj.value.trim() == bnk.subj_bank.trim();
                      });
                      if (bnk1[0]) {
                        bnk.subj_bank = bnk1[0];
                        console.log("subj_bank");
                        console.log(bank1[0]);
                      }
                    }
                    if (bnk.subj_bank_acc_status === "1")
                      bnk.subj_bank_acc_status = true;
                    else bnk.subj_bank_acc_status = false;
                    return bnk;
                  });
                });
            });

          this.socials_person = response.data.person_socials;
          this.socials = response.data.socials;
          this.organization = response.data.organizations;
          if (
            typeof this.organization.logo === "undefined" ||
            this.organization.logo == ""
          )
            this.organization.logo = "https://via.placeholder.com/450?text=+";
          this.person = response.data.persons;
          if (
            typeof this.person.avatar === "undefined" ||
            this.person.avatar == ""
          )
            this.person.avatar = "https://via.placeholder.com/450?text=+";
          this.person.date_of_birth = this.person.date_of_birth;
          this.person.gender = parseInt(this.person.gender);
          this.residency = response.data.org_residency;
          this.organization.country = response.data.org_residency;

          this.organization.org_reg_date = this.momentum(
            this.organization.org_reg_date,
          );
          this.organization.org_reregdate = this.momentum(
            this.organization.org_reregdate,
          );
          this.organization.company_ceo_date = this.momentum(
            this.organization.company_ceo_date,
          );
          if (response.data.organizations.org_oked != null) {
            axios
              .get(
                window.base +
                "/library/oked?code=" +
                response.data.organizations.org_oked +
                "&lang=" +
                this.$i18n.locale,
              )
              .then((response) => {
                this.organization.org_oked = response.data[0];
              });
          }
          if (response.data.persons.country != null) {
            axios
              .get(
                window.base +
                "/library/country?code=" +
                response.data.persons.country +
                "&lang=" +
                this.$i18n.locale,
              )
              .then((response) => {
                this.person.country = response.data[0];
              });
          }
          if (response.data.organizations.company_status !== null)
            this.findLibValue(
              "status",
              typeof response.data.organizations.company_status !== "undefined"
                ? response.data.organizations.company_status
                : "1",
              "company_status",
            );
          else
            this.organization.company_status = { value: "", display_text: "" };
          console.log(response.data.organizations.org_type);
          if (response.data.organizations.org_type != null) {
            axios
              .get(
                window.base +
                "/library/org_type?code=" +
                response.data.organizations.org_type +
                "&lang=" +
                this.$i18n.locale,
              )
              .then((response) => {
                this.organization.org_type = response.data[0];
              });
          }
          this.processOrganizationKpveds();
          response.data.addresses.forEach((address) => {
            if (address.subj_post_addr_type == 1) {
              this.address_1 = address;
            }
            if (address.subj_post_addr_type == 2) {
              this.address_2 = address;
            }
            if (address.subj_post_addr_type == 3) {
              this.address_3 = address;
            }
          });
          axios
            .get(
              window.base +
              "/library?type=country&query=&qty=10000" +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((res) => {
              var countriesList = res.data;
              console.log(countriesList, this.address_1);
              if (typeof this.address_1 == "undefined")
                this.address_1 = {
                  post_addr_index: "",
                  post_addr_country: { value: "", display_text: "" },
                  post_addr_region: "",
                  post_addr_district: "",
                  post_addr_town: "",
                  post_addr_city: "",
                  post_addr_streethouse: "",
                  post_addr_house: "",
                  post_addr_room: "",
                  post_addr_comm_number: "",
                };
              else {
                this.address_1.post_addr_country =
                  countriesList[
                  countriesList.findIndex(
                    (i) => i.value == this.address_1.post_addr_country.trim(),
                  )
                  ];
              }

              if (typeof this.address_2 == "undefined")
                this.address_2 = {
                  post_addr_index: "",
                  post_addr_country: { value: "", display_text: "" },
                  post_addr_region: "",
                  post_addr_district: "",
                  post_addr_town: "",
                  post_addr_city: "",
                  post_addr_streethouse: "",
                  post_addr_house: "",
                  post_addr_room: "",
                  post_addr_comm_number: "",
                };
              else
                this.address_2.post_addr_country =
                  countriesList[
                  countriesList.findIndex(
                    (i) => i.value == this.address_2.post_addr_country.trim(),
                  )
                  ];
              if (typeof this.address_3 == "undefined")
                this.address_3 = {
                  post_addr_index: "",
                  post_addr_country: { value: "", display_text: "" },
                  post_addr_region: "",
                  post_addr_district: "",
                  post_addr_town: "",
                  post_addr_city: "",
                  post_addr_streethouse: "",
                  post_addr_house: "",
                  post_addr_room: "",
                  post_addr_comm_number: "",
                };
              else
                this.address_3.post_addr_country =
                  countriesList[
                  countriesList.findIndex(
                    (i) => i.value == this.address_3.post_addr_country.trim(),
                  )
                  ];
              if (typeof this.address_1.post_addr_country == "undefined")
                this.address_1.post_addr_country = {
                  value: "",
                  display_text: "",
                };
              if (typeof this.address_2.post_addr_country == "undefined")
                this.address_2.post_addr_country = {
                  value: "",
                  display_text: "",
                };
              if (typeof this.address_3.post_addr_country == "undefined")
                this.address_3.post_addr_country = {
                  value: "",
                  display_text: "",
                };
            });
        });
      } else {
        let response = { data: {} };
        response.data = this.$store.state.firmfull;

        this.subj_bank_accounts = response.data.banks;
        axios
          .get(
            window.base +
            "/library?type=currency&query=&qty=10000" +
            "&lang=" +
            this.$i18n.locale,
          )
          .then((res) => {
            var currencyList = res.data;
            this.subj_bank_accounts.forEach((bnk) => {
              if (bnk.subj_bank_acc_curr) {
                var curr = currencyList.filter((obj) => {
                  return (
                    parseInt(obj.value) === parseInt(bnk.subj_bank_acc_curr)
                  );
                });
                bnk.subj_bank_acc_curr = curr[0];
              }

              return bnk;
            });
          });
        this.socials_person = response.data.person_socials;
        this.socials = response.data.socials;
        this.organization = response.data.organizations;
        if (
          typeof this.organization.logo === "undefined" ||
          this.organization.logo == ""
        )
          this.organization.logo = "https://via.placeholder.com/450?text=+";
        this.person = response.data.persons;
        if (
          typeof this.person.avatar === "undefined" ||
          this.person.avatar == ""
        )
          this.person.avatar = "https://via.placeholder.com/450?text=+";
        this.person.date_of_birth = this.person.date_of_birth;
        this.person.gender = parseInt(this.person.gender);
        this.residency = response.data.org_residency;
        this.organization.country = response.data.org_residency;

        this.organization.org_reg_date = this.momentum(
          this.organization.org_reg_date,
        );
        this.organization.org_reregdate = this.momentum(
          this.organization.org_reregdate,
        );
        this.organization.company_ceo_date = this.momentum(
          this.organization.company_ceo_date,
        );
        if (response.data.organizations.org_oked != null) {
          axios
            .get(
              window.base +
              "/library/oked?code=" +
              response.data.organizations.org_oked +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((response) => {
              this.organization.org_oked = response.data[0];
            });
        }
        if (response.data.persons.country != null) {
          axios
            .get(
              window.base +
              "/library/country?code=" +
              response.data.persons.country +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((response) => {
              this.person.country = response.data[0];
            });
        }
        if (
          response.data.organizations.company_status !== null &&
          typeof response.data.organizations.company_status != "object"
        )
          this.findLibValue(
            "status",
            typeof response.data.organizations.company_status !== "undefined"
              ? response.data.organizations.company_status
              : "1",
            "company_status",
          );
        else this.organization.company_status = { value: "", display_text: "" };

        if (
          response.data.organizations.org_type != null &&
          typeof response.data.organizations.org_type != "object"
        ) {
          axios
            .get(
              window.base +
              "/library/org_type?code=" +
              response.data.organizations.org_type +
              "&lang=" +
              this.$i18n.locale,
            )
            .then((response) => {
              this.organization.org_type = response.data[0];
            });
        }
        this.processOrganizationKpveds();
        response.data.addresses.forEach((address) => {
          if (address.subj_post_addr_type == 1) {
            this.address_1 = address;
          }
          if (address.subj_post_addr_type == 2) {
            this.address_2 = address;
          }
          if (address.subj_post_addr_type == 3) {
            this.address_3 = address;
          }
        });
        axios
          .get(
            window.base +
            "/library?type=country&query=&qty=10000" +
            "&lang=" +
            this.$i18n.locale,
          )
          .then((res) => {
            var countriesList = res.data;
            if (typeof this.address_1 == "undefined")
              this.address_1 = {
                post_addr_index: "",
                post_addr_country: { value: "", display_text: "" },
                post_addr_region: "",
                post_addr_district: "",
                post_addr_town: "",
                post_addr_city: "",
                post_addr_streethouse: "",
                post_addr_house: "",
                post_addr_room: "",
                post_addr_comm_number: "",
              };
            else
              this.address_1.post_addr_country =
                countriesList[
                countriesList.findIndex(
                  (i) => i.value == this.address_1.post_addr_country.trim(),
                )
                ];
            if (typeof this.address_2 == "undefined")
              this.address_2 = {
                post_addr_index: "",
                post_addr_country: { value: "", display_text: "" },
                post_addr_region: "",
                post_addr_district: "",
                post_addr_town: "",
                post_addr_city: "",
                post_addr_streethouse: "",
                post_addr_house: "",
                post_addr_room: "",
                post_addr_comm_number: "",
              };
            else
              this.address_2.post_addr_country =
                countriesList[
                countriesList.findIndex(
                  (i) => i.value == this.address_2.post_addr_country.trim(),
                )
                ];
            if (typeof this.address_3 == "undefined")
              this.address_3 = {
                post_addr_index: "",
                post_addr_country: { value: "", display_text: "" },
                post_addr_region: "",
                post_addr_district: "",
                post_addr_town: "",
                post_addr_city: "",
                post_addr_streethouse: "",
                post_addr_house: "",
                post_addr_room: "",
                post_addr_comm_number: "",
              };
            else
              this.address_3.post_addr_country =
                countriesList[
                countriesList.findIndex(
                  (i) => i.value == this.address_3.post_addr_country.trim(),
                )
                ];
            if (typeof this.address_1.post_addr_country == "undefined")
              this.address_1.post_addr_country = {
                value: "",
                display_text: "",
              };
            if (typeof this.address_2.post_addr_country == "undefined")
              this.address_2.post_addr_country = {
                value: "",
                display_text: "",
              };
            if (typeof this.address_3.post_addr_country == "undefined")
              this.address_3.post_addr_country = {
                value: "",
                display_text: "",
              };
          });
      }

      axios.get(window.base + "/account/load_founders").then((response) => {
        this.organizations_founders = response.data;
        if (
          !_.isArray(this.organizations_founders) ||
          _.isEmpty(this.organizations_founders)
        )
          this.organizations_founders = [];
        else {
          this.organizations_founders.map((founder) => {
            if (founder.org_founders_country) {
              axios
                .get(
                  window.base +
                  "/library/country/?code=" +
                  founder.org_founders_country +
                  "&lang=" +
                  this.$i18n.locale,
                )
                .then((r) => {
                  founder.org_founders_country = r.data[0];
                });
            } else {
              console.log("atejo i else");
              founder.org_founders_country.value = "";
              founder.org_founders_country.display_text = "";
            }

            return founder;
          });
        }
      });
      axios
        .get(
          window.base +
          "/library?type=pa_document_type&query=&qty=100" +
          "&lang=" +
          this.$i18n.locale,
        )
        .then((res2) => {
          var documentTypes = [];
          res2.data.forEach((item) => {
            if (item.value !== "··········") documentTypes.push(item);
          });

          axios
            .get(window.base + "/document/LoadCompanyDocuments")
            .then((response1) => {
              this.company_documents = response1.data;
              if (
                !_.isArray(this.company_documents) ||
                _.isEmpty(this.company_documents)
              )
                this.company_documents = [];
              else {
                this.company_documents.forEach((doc) => {
                  var docType = documentTypes.filter((obj) => {
                    return obj.value === doc.document_type;
                  });
                  doc.document_type = docType[0];
                  doc.is_active = parseInt(doc.is_active);
                  doc.document_date = this.momentum(doc.document_date);
                  doc.document_exp_date = this.momentum(doc.document_exp_date);
                });
              }

              axios
                .get(window.base + "/document/LoadPersonDocuments")
                .then((res1) => {
                  this.person_documents = res1.data;
                  if (
                    !_.isArray(this.person_documents) ||
                    _.isEmpty(this.person_documents)
                  )
                    this.person_documents = [];
                  else {
                    this.person_documents.forEach((doc) => {
                      var docType = documentTypes.filter((obj) => {
                        return obj.value === doc.document_type;
                      });
                      doc.document_type = docType[0];
                      doc.is_active = parseInt(doc.is_active);
                      doc.document_date = this.momentum(doc.document_date);
                      doc.document_exp_date = this.momentum(
                        doc.document_exp_date,
                      );
                    });
                  }
                });
            });
        });
    },
    momentum_time(date) {
      //date = date.replace(' ','T')
      return moment(date).format("DD.MM.Y HH:mm");
    },
    momentum(dt) {
      if (_.isEmpty(dt)) return "";
      if (!moment(dt).isValid()) return "";
      //regexp check formats
      let re1 = /^[0-9]{2,4}\.[0-9]{1,2}\.[0-9]{1,2}$/gm;
      let re2 = /^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{2,4}$/gm;
      if (re1.test(dt)) {
        dt = dt.split(".");
        if (dt.length == 3) {
          dt = dt[0] + "-" + dt[1] + "-" + dt[2];
        } else {
          return "";
        }
      }
      if (re2.test(dt)) {
        dt = dt.split(".");
        if (dt.length == 3) {
          dt = dt[2] + "-" + dt[1] + "-" + dt[0];
        } else {
          return "";
        }
      }
      var m = moment(dt).format("YYYY-MM-DD");
      return m;
    },
    gender(gender) {
      return gender == 0
        ? this.$t("message.account.male")
        : this.$t("message.account.female");
    },
    show_user() {
      this.show = 1;
      setTimeout(() => {
        try {
          this.showMap();
        } catch (e) {
          console.log("map loading error...");
        }
      }, 2000);
    },
    show_company() {
      this.show = 2;
      setTimeout(() => {
        try {
          this.showMapCompany();
        } catch (e) {
          console.log("map loading error...");
        }
      }, 2000);
    },
    editPerson() {
      if (this.edit_person == false) {
        this.edit_person = true;
        this.fetchOrgTypes("");
        this.fetchCountries("");
        this.fetchCurrency("");
        this.fetchDocumentTypes("");
        this.fetchOkeds("");
        this.fetchStatuses("");
      } else {
        this.savePerson();
      }
    },
    editCompany() {
      if (this.edit_company == false) {
        this.edit_company = true;
        this.fetchOrgTypes("");
        this.fetchCountries("");
        this.fetchCurrency("");
        this.fetchDocumentTypes("");
        this.fetchOkeds("");
        this.fetchStatuses("");
      } else this.saveCompany();
    },
    viewOffers() {
      if (this.view_offers == false) {
        this.view_offers = true;
        this.show = 3;
      }
    },
    savePerson() {
      jQuery(".error-description").remove();
      jQuery(".row.error").removeClass("error");
      this.edit_person = false;
      var formdata = new FormData();
      for (var i in this.person) {
        if (i !== "country" && i !== "gender")
          formdata.append(i, this.person[i]);
      }
      formdata.append("gender", this.person.gender === true ? 1 : 0);
      formdata.append("country", this.person.country.value);

      axios.post(window.base + "/account/save", formdata).then((response) => {
        if (response.data.status == "ok") {
          this.$store.commit("update_firm_person", this.person);
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
          axios.get(window.base + "/document/getfirmfull").then((response) => {
            this.$store.commit("load_firm", response.data);
          });
        } else {
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$root.$t("message.message.no_success") +
              " (" +
              response.data.message +
              ")",
            timeout: 5000,
          }).show();
        }
      });
    },
    saveCompany() {
      jQuery(".error-description").remove();
      jQuery(".row.error").removeClass("error");
      this.edit_company = false;
      var formdata = new FormData();
      for (var i in this.organization) {
        if (
          i == "org_is_bank" ||
          i == "org_is_broker" ||
          i == "org_is_carrier" ||
          i == "org_is_insurer"
        ) {
          if (this.organization[i] === true) this.organization[i] = 1;
          if (this.organization[i] === false) this.organization[i] = 0;
        }
        if (i == "org_oked") {
          if (
            typeof this.organization[i] !== "undefined" &&
            typeof this.organization[i].value !== "undefined"
          )
            formdata.append(i, this.organization[i].value);
          else formdata.append(i, "");
        } else if (i == "org_residency") {
        } else if (i == "country") {
          if (
            typeof this.organization[i] !== "undefined" &&
            typeof this.organization[i].value !== "undefined"
          )
            formdata.append("org_residency", this.organization[i].value);
          else formdata.append("org_residency", "");
        } else if (i == "company_status") {
          if (
            typeof this.organization[i] !== "undefined" &&
            typeof this.organization[i].value !== "undefined"
          )
            formdata.append(i, this.organization[i].value);
          else formdata.append(i, "");
        } else if (i == "country") {
          if (
            typeof this.organization[i] !== "undefined" &&
            typeof this.organization[i].value !== "undefined"
          )
            formdata.append(i, this.organization[i].value);
          else formdata.append(i, "");
        } else if (i == "org_type") {
          if (
            typeof this.organization[i] !== "undefined" &&
            typeof this.organization[i].value !== "undefined"
          )
            formdata.append(i, this.organization[i].value);
          else formdata.append(i, "");
        } else {
          formdata.append(i, this.organization[i]);
        }
      }
      // formdata.append('residency', this.residency.value)
      axios
        .post(window.base + "/account/save_organization", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            this.$store.commit("update_firm_company", this.organization);
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.no_success") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
    },
    saveSocials() {
      var formdata = new FormData();
      for (var i in this.socials) {
        formdata.append(i, this.socials[i]);
      }
      axios
        .post(window.base + "/account/save_socials", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            this.$store.commit("update_firm_socials", this.socials);
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.no_success") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
      this.$bvModal.hide("modal-socials");
    },
    saveSocialsPerson() {
      var formdata = new FormData();
      for (var i in this.socials_person) {
        formdata.append(i, this.socials_person[i]);
      }
      axios
        .post(window.base + "/account/save_socials_personal", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            this.$store.commit(
              "update_firm_person_socials",
              this.socials_person,
            );
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.no_success") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
      this.$bvModal.hide("modal-socials-persons");
    },
    savePassword() {
      if (
        !_.isEmpty(this.old_password) &&
        !_.isEmpty(this.new_password) &&
        !_.isEmpty(this.confirm_password)
      ) {
        if (this.new_password != this.confirm_password) {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.account.passwords_not_equal"),
            timeout: 5000,
          }).show();
        } else {
          var formdata = new FormData();
          formdata.append("old_password", this.old_password);
          formdata.append("new_password", this.new_password);
          axios
            .post(window.base + "/account/savePassword", formdata)
            .then((response) => {
              if (response.data.status == "ok") {
                this.$bvModal.hide("modal-change-password");
                this.wrong_old_password = false;
              } else {
                if (response.data.status == "Incorrect password.") {
                  this.wrong_old_password = true;
                } else {
                  if (
                    response.data.status ==
                    "Пароль должен иметь длинну 8 символов"
                  ) {
                    this.short_new_password = true;
                  } else {
                    this.insecure_new_password = true;
                  }
                }
              }
            });
        }
      } else {
        new Noty({
          theme: "light",
          type: "error",
          text: this.$t("message.account.fill_all_fields"),
          timeout: 5000,
        }).show();
      }
    },
    saveBanks() {
      var formdata = new FormData();
      this.subj_bank_accounts.forEach((bank, i) => {
        console.log("bankai");
        console.log(bank.subj_bank);
        formdata.append("subj_bank[" + i + "]", bank.subj_bank.value);
        formdata.append(
          "subj_bank_acc_number[" + i + "]",
          bank.subj_bank_acc_number,
        );
        formdata.append(
          "subj_bank_acc_curr[" + i + "]",
          bank.subj_bank_acc_curr.value,
        );
        formdata.append(
          "subj_bank_acc_status[" + i + "]",
          bank.subj_bank_acc_status,
        );
      });
      axios
        .post(window.base + "/account/save_banks", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            this.$store.commit("update_firm_banks", this.subj_bank_accounts);
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.no_success") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
      this.$bvModal.hide("modal-account");
    },
    saveFounders() {
      var formdata = new FormData();
      this.organizations_founders.forEach((founder, i) => {
        formdata.append(
          "org_founders_person_name[" + i + "]",
          founder.org_founders_person_name,
        );
        formdata.append(
          "org_founders_company[" + i + "]",
          founder.org_founders_company,
        );
        if (founder.org_founders_country)
          formdata.append(
            "org_founders_country[" + i + "]",
            founder.org_founders_country.value,
          );
        formdata.append(
          "org_founders_share[" + i + "]",
          founder.org_founders_share,
        );
      });

      axios.post(window.base + "/account/save_founders", formdata).then((r) => {
        if (r.data.status == "ok") {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
          this.$bvModal.hide("modal-founders");
        } else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success"),
            timeout: 5000,
          }).show();
        }
      });
    },
    saveAddresses() {
      var formdata = new FormData();
      formdata.append("subj_post_addr_type[0]", 1);
      formdata.append("post_addr_index[0]", this.address_1.post_addr_index);
      formdata.append(
        "post_addr_country[0]",
        this.address_1.post_addr_country.value,
      );
      formdata.append("post_addr_region[0]", this.address_1.post_addr_region);
      formdata.append(
        "post_addr_district[0]",
        this.address_1.post_addr_district,
      );
      formdata.append("post_addr_town[0]", this.address_1.post_addr_town);
      formdata.append("post_addr_city[0]", this.address_1.post_addr_city);
      formdata.append(
        "post_addr_streethouse[0]",
        this.address_1.post_addr_streethouse,
      );
      formdata.append("post_addr_house[0]", this.address_1.post_addr_house);
      formdata.append("post_addr_room[0]", this.address_1.post_addr_room);
      formdata.append(
        "post_addr_comm_number[0]",
        this.address_1.post_addr_comm_number,
      );

      formdata.append("subj_post_addr_type[1]", 3);
      formdata.append("post_addr_index[1]", this.address_3.post_addr_index);
      formdata.append(
        "post_addr_country[1]",
        this.address_3.post_addr_country.value,
      );
      formdata.append("post_addr_region[1]", this.address_3.post_addr_region);
      formdata.append(
        "post_addr_district[1]",
        this.address_3.post_addr_district,
      );
      formdata.append("post_addr_town[1]", this.address_3.post_addr_town);
      formdata.append("post_addr_city[1]", this.address_3.post_addr_city);
      formdata.append(
        "post_addr_streethouse[1]",
        this.address_3.post_addr_streethouse,
      );
      formdata.append("post_addr_house[1]", this.address_3.post_addr_house);
      formdata.append("post_addr_room[1]", this.address_3.post_addr_room);
      formdata.append(
        "post_addr_comm_number[1]",
        this.address_3.post_addr_comm_number,
      );

      formdata.append("subj_post_addr_type[2]", 2);
      formdata.append("post_addr_index[2]", this.address_2.post_addr_index);
      formdata.append(
        "post_addr_country[2]",
        this.address_2.post_addr_country.value,
      );
      formdata.append("post_addr_region[2]", this.address_2.post_addr_region);
      formdata.append(
        "post_addr_district[2]",
        this.address_2.post_addr_district,
      );
      formdata.append("post_addr_town[2]", this.address_2.post_addr_town);
      formdata.append("post_addr_city[2]", this.address_2.post_addr_city);
      formdata.append(
        "post_addr_streethouse[2]",
        this.address_2.post_addr_streethouse,
      );
      formdata.append("post_addr_house[2]", this.address_2.post_addr_house);
      formdata.append("post_addr_room[2]", this.address_2.post_addr_room);
      formdata.append(
        "post_addr_comm_number[2]",
        this.address_2.post_addr_comm_number,
      );

      axios
        .post(window.base + "/account/save_addresses", formdata)
        .then((response) => {
          if (response.data.status == "ok") {
            this.$store.commit("update_firm_addresses", [
              this.address_1,
              this.address_2,
              this.address_3,
            ]);
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.no_success") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });

      this.$bvModal.hide("modal-addresses");
    },
    showMap() {
      if (
        document.querySelectorAll("#person_map").length > 0 &&
        this.show == 1
      ) {
        this.loading_map = true;
        if (typeof ymaps !== "undefined") {
          var address = this.person.post_address;
          if (_.isEmpty(address)) address = "Казахстан, Нур-Султан";
          axios
            .get(
              "https://geocode-maps.yandex.ru/1.x?geocode=" +
              address +
              "&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4&format=json",
            )
            .then((response) => {
              if (
                typeof response.data.response.GeoObjectCollection
                  .featureMember !== "undefined" &&
                response.data.response.GeoObjectCollection.featureMember
                  .length > 0
              ) {
                var latlng =
                  response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(
                    " ",
                  );
                document.querySelector("#person_map").innerHTML = "";
                this.map = new ymaps.Map(
                  "person_map",
                  {
                    center: [latlng[1], latlng[0]],
                    zoom: 17,
                  },
                  {
                    searchControlProvider: "yandex#search",
                  },
                );
                this.map_point = new ymaps.GeoObject(
                  {
                    // Описание геометрии.
                    geometry: {
                      type: "Point",
                      coordinates: [latlng[1], latlng[0]],
                    },
                  },
                  {
                    // Опции.
                    // Иконка метки будет растягиваться под размер ее содержимого.
                    preset: "islands#blackStretchyIcon",
                    // Метку можно перемещать.
                    // draggable: true
                  },
                );
                this.map.geoObjects.add(this.map_point);
                this.loading_map = false;
              }
            });
        }
      }
    },
    showMapCompany() {
      if (
        document.querySelectorAll("#company_map").length > 0 &&
        this.show == 2
      ) {
        this.loading_map_company = true;
        if (typeof ymaps !== "undefined") {
          var address =
            this.address_2.post_addr_country.display_text +
            " " +
            this.address_2.post_addr_town +
            " " +
            this.address_2.post_addr_streethouse +
            " " +
            this.address_2.post_addr_house;
          if (_.isEmpty(address.trim())) address = "Казахстан, Нур-Султан";
          axios
            .get(
              "https://geocode-maps.yandex.ru/1.x?geocode=" +
              address +
              "&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4&format=json",
            )
            .then((response) => {
              if (
                typeof response.data.response.GeoObjectCollection
                  .featureMember !== "undefined" &&
                response.data.response.GeoObjectCollection.featureMember
                  .length > 0
              ) {
                var latlng =
                  response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(
                    " ",
                  );
                document.querySelector("#company_map").innerHTML = "";
                this.map_company = new ymaps.Map(
                  "company_map",
                  {
                    center: [latlng[1], latlng[0]],
                    zoom: 17,
                  },
                  {
                    searchControlProvider: "yandex#search",
                  },
                );
                this.map_point_company = new ymaps.GeoObject(
                  {
                    // Описание геометрии.
                    geometry: {
                      type: "Point",
                      coordinates: [latlng[1], latlng[0]],
                    },
                  },
                  {
                    // Опции.
                    // Иконка метки будет растягиваться под размер ее содержимого.
                    preset: "islands#blackStretchyIcon",
                    // Метку можно перемещать.
                    // draggable: true
                  },
                );
                this.map_company.geoObjects.add(this.map_point_company);
                this.loading_map_company = false;
              }
            });
        }
      }
    },
    loadBankPreContracts() {
      axios.get(
        `contract/getbankcontracts?customer_id=${this.$store.state.user.id}`
      ).then((response) => {
        this.bank_pre_contracts.contracts = response.data[0].contracts;
      });
    },
  },
  watch: {
    edit_company() {
      this.processOrganizationKpveds();
    },
    person: {
      deep: true,
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          setTimeout(() => {
            try {
              this.showMap();
            } catch (e) {
              console.log("map loading error...");
            }
          }, 2000);
        }, 2000);
      },
    },
    organization: {
      deep: true,
      handler: function (organization) {
        // There is so many request, that I don't even know where to put this
        // So simply watching org_is_bank value, and if true I load contracts
        if (organization.org_is_bank) this.loadBankPreContracts();
      }
    }
  },
};
</script>
<style type="text/css">
.loading-map {
  background-image: url(data:image/gif;base64,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);
  background-repeat: no-repeat;
  background-position: center;
}

.vs--single .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}

#person_map,
#company_map {
  overflow-x: hidden;
}

/**
		Validation
	*/
.validation-frame {
  position: fixed;
  background: white;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  box-shadow:
    0 16px 24px 2px rgb(0 0 0 / 14%),
    0 6px 30px 5px rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  border-radius: 10px;
  z-index: 1231231231;
  transition: top 0.5s;
  max-height: calc(100vh - 100px);
}

.validation-frame .validation-frame-inner {
  max-height: calc(100vh - 140px);
  overflow: auto;
}

.validation-frame.arrow.top:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 7.5px 10px 7.5px;
  border-color: transparent transparent #fff transparent;
  position: absolute;
  right: 20px;
  top: -5px;
}

.validation-frame.arrow.left:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 15px 15px 0;
  border-color: transparent #fff transparent transparent;
  position: absolute;
  left: -8px;
  top: 0;
}

.validation-frame .btn.btn-link {
  position: absolute;
  right: -20px;
  top: -10px;
}

.form-group.error,
.row.error {
  /* background: rgba(255,0,0,.1); */
  padding: 10px;
  box-shadow: 0 2px 25px rgba(255, 0, 0, 0.1);
}

.form-group.error label,
.row.error label {
  color: #f44336;
}

.form-group.error .error-description,
.row.error .error-description {
  color: #f44336;
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
}

.form-group input[type="file"].form-control1 {
  position: static;
  opacity: 1;
}

.balance-block.bg-secondary {
  background-color: #eeeeee !important;
}

.balance-block.rounded {
  border-radius: 8px;
}

.edit-profile-button {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 8px;

  height: 40px;

  /* attis/gradient light */

  background: linear-gradient(90deg, #259fe2 0%, #46b1e2 100%);
  border-radius: 8px;
  font-family: "Roboto" !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  /* identical to box height, or 143% */
  border: 0 !important;
  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}

.change-pwd-button {
  font-family: "Roboto" !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  gap: 10px;
  margin-left: auto;
  /* identical to box height, or 143% */

  display: inline-flex;
  align-items: center;
  letter-spacing: 0.1px;

  /* attis/primary10 */

  color: var(--color1);
}

.change-pwd-button:hover {
  color: var(--color2);
}

.change-pwd-button:hover svg path,
.change-pwd-button:hover svg rect {
  stroke: var(--color2);
}

.client-status span {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* neutral/30 */

  color: #797980;
}

.client-status+div .bg-warning {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  padding: 4px 12px !important;
  gap: 4px !important;

  height: 28px !important;

  /* gradient/gradient10 */

  background: linear-gradient(84.89deg,
      #fd670b 4.81%,
      #fc9923 98.28%) !important;
  border-radius: 8px !important;
  font-family: "Roboto" !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px !important;

  /* primary100 */

  color: #ffffff !important;
  margin-top: 8px;
}

.balance-block .icon {
  width: 40px;
  height: 40px;

  /* primary100 */

  background: #ffffff;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance-block {
  padding: 16px;
}

.balance-block label {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: flex;
  align-items: center;

  /* neutral/10 */

  color: #333333;
  margin-bottom: 0;
}

.balance-block div span {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.1px;

  /* neutral/10 */

  color: #333333;
}

.account-content-block {
  margin-bottom: 14px;
}

.account-content-block:nth-child(1),
.account-content-block:nth-child(2) {
  margin-top: 10px;
}

.account-content-block .label {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  margin-bottom: 8px;
}

.account-content-block .label.editing-label {
  background: #fff;
  width: auto;
  position: absolute;
  margin-top: -8px;
  padding: 0 4px;
  left: 25px;
}

.account-content-block .value {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* neutral/10 */

  color: #333333;
}

.editing-label+div .form-control {
  border: 1px solid #797980 !important;
  border-radius: 4px !important;
}

.form-group {
  position: relative;
}

.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}

.form-group input::placeholder {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* neutral/30 */

  color: #797980;
}

.modal-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  /* identical to box height, or 117% */

  /* attis/primary */

  color: #04416d;
}

.modal-header {
  border-bottom: 0 !important;
}

.modal .form-group {
  margin-bottom: 28px;
}

.modal-md {
  max-width: 600px !important;
}

.btn-outline-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 40px;
  gap: 16px;

  height: 48px;

  /* neutral/10 */

  border: 1px solid #333333;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* neutral/10 */

  color: #333333;
}

.btn-primary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 40px;
  gap: 16px;

  height: 48px;

  /* attis/gradient light */

  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
  border: 0 !important;
}

.gap-20 {
  gap: 20px;
}

.value .form-control:hover,
.form-group .form-control:hover {
  border-color: #333333 !important;
  box-shadow: none !important;
}

.value .form-control:focus,
.form-group .form-control:focus {
  border-color: var(--color2) !important;
  box-shadow: none !important;
}
</style>
